const data = [
    {
        "id": 1,
        "date": "2025-02-28",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "USAGM",
          // "story": "Dismantle USAGM's journalism "firewall" to align its reporting with the aims of the president.",
          "story": "Dismantling USAGM's journalism 'firewall' -- removing protections for its journalists and allowing the president's administration to control their reporting to align with its goals.",
          "implications": "Journalists face HR violations or put on leave for speaking against POTUS. This shift towards state-controlled media results in biased information being disseminated both domestically and internationally, undermining the credibility of US news and harming informed public discourse and policy decisions.",
          "sources": [
            {
              "name": "Project 2025",
              "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=277"
            },
            {   "name": "New York Times",
                "url": "https://www.nytimes.com/2025/02/28/business/voice-of-america-trump.html"
            },
            {
              "name": "Axios",
              "url": "https://www.axios.com/2025/03/24/voa-employees-lawsuit-trump-usagm"
            },
            { "name": "IFJ", "url": "https://www.ifj.org/media-centre/news/detail/category/press-releases/article/usa-thousands-of-journalists-at-risk-of-unemployment-as-usagm-faces-dismantling" }
          ]
        },
        "goodData": [
          {
            "verse": "John 8:32",
            "text": "Then you will know the truth, and the truth will set you free.",
            "implication": "Emphasizes the importance of truth and transparency in media."
          },
          {
            "verse": "Matthew 5:14-16",
            "text": "You are the light of the world...",
            "implication": "Highlights the role of media as a beacon of light, promoting openness and accountability."
          }
        ],
        "tags": ["media", "government"]
      }, //good
      {
        "id": 2,
        "date": "2025-03-12",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "Education",
          //"story": "Cease investigating Title VI disparate impact cases. (This federal law prohibits discrimination on the basis of race, color, or national origin in programs and activities receiving federal financial assistance.)",
          "story": "Halt investigations into Title VI disparate impact cases, meaning the government will no longer proactively examine policies for unintentional discriminatory effects based on race, color, or national origin.",
          "implications": "Undermines protections for marginalized students, promotes inequality. 'Note: Effectively achieved by closing most civil rights offices; staff say it will be “virtually impossible” to resolve discrimination complaints.",
          "sources": [
            {
              "name": "Project 2025",
              "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=368"
            },
            {
              "name": "ProPublica",
              "url": "https://www.propublica.org/article/2025/03/15/education-department-policy-changes-title-ix-crt"
            },
            { "name": "ProPublica",
                "url": "https://www.propublica.org/article/education-department-civil-rights-division-eroded-by-massive-layoffs"
            },
            { "name": "NEA", "url": "https://www.nea.org/nea-today/all-news-articles/how-project-2025-would-devastate-public-education" }
          ]
        },
        "goodData": [
          {
            "verse": "James 2:9",
            "text": "But if you show favoritism, you sin and are convicted by the law as lawbreakers.",
            "implication": "Ceasing investigations into disparate impact allows favoritism and discrimination to persist, which Jesus, through James's teaching, would condemn as sinful."
          },
          {
            "verse": "Matthew 25:40",
            "text": "Truly I tell you, whatever you did for one of the least of these brothers and sisters of mine, you did for me.",
            "implication": "Emphasizes caring for marginalized and vulnerable individuals."
          },
          {
            "verse": "Luke 10:30-37",
            "text": "The Parable of the Good Samaritan.",
            "implication": "Encourages compassion and assistance to those in need, regardless of their background."
          }
        ],
        "tags": ["education", "civil rights"]
      }, //good
      {
        "id": 3,
        "date": "2025-03-14",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "EPA",
          "story": "Roll back haze reduction.",
          // Pause/review grants; Downsize; Eliminate Environmental Justice office; Stop grants to advocacy groups; Eliminate social cost of carbon; Undermine CA waiver; Eliminate Fossil Energy office; Eliminate Clean Energy Corps.",
          "implications": "Harms environmental protection, disproportionately affecting vulnerable communities.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=457"
            },
            { "name": "EPA",
                "url": "https://www.epa.gov/newsreleases/administrator-zeldin-begins-restructuring-regional-haze-program"
            },
            // {
            //   "name": "AP News",
            //   "url": "https://apnews.com/article/2025/03/15/epa-policy-changes-environmental-justice-office-closure"
            // },
          ]
        },
        "goodData": [
          {
            "verse": "Mark 4:39",
            "text": "He got up, rebuked the wind and said to the waves, 'Quiet! Be still!' Then the wind died down and it was completely calm.",
            "implication": "Demonstrates Jesus' authority over nature and the importance of caring for creation."
          },
          {
            "verse": "Matthew 6:26",
            "text": "Look at the birds of the air; they do not sow or reap or store away in barns, and yet your heavenly Father feeds them.",
            "implication": "Highlights God's care for all creatures and the importance of preserving the environment."
          },
          {
            "verse": "Revelation 11:18",
            "text": "The time has come... for destroying those who destroy the earth.",
            "implication": "Warns against actions that harm the earth and emphasizes the need for environmental stewardship."
          }
        ],
        "tags": ["environment"]
      }, //good
      {
        "id": 4,
        "date": "2025-03-04",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "Commerce",
          "story": "Abolish non-statuory standing comittees within the Census Bureau, including the Census Scientific Advisory Committee",
          "implications": "Without independent scientific oversight, census data will become more susceptible to political influence, leading to inaccurate or biased results.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=715"
            },
            { "name": "AP News",
                "url": "https://apnews.com/article/census-bureau-commerce-department-howard-lutnick-3a56003b790aedce6e6c8ddd7c6b6943"
            },
          ]
        },
        "goodData": [
          {
            "verse": "John 8:32",
            "text": "Then you will know the truth, and the truth will set you free.",
            "implication": "Implication: Jesus values truth and accuracy. Removing scientific oversight could compromise the integrity of census data, hindering the pursuit of truth."
          },
          {
            "verse": "Matthew 5:14-16",
            "text": "You are the light of the world. A town built on a hill cannot be hidden. Neither do people light a lamp and put it under1 a bowl. Instead they put it on its stand, and it gives light to everyone in the house. In the same way, let your light shine before others, that they may see your good deeds and glorify your Father in heaven.",
            "implication": "Jesus calls his followers to be transparent and to let their light shine. Removing scientific advisory committees removes some of the light and transparency from the census bureau."
          },
          {
            "verse": "Luke 12:2",
            "text": "There is nothing concealed that will not be disclosed, or hidden that will not be made known.",
            "implication": "Jesus emphasizes the importance of transparency and accountability. Removing independent oversight will conceal biases or inaccuracies in the census."
          }
        ],
        "tags": ["census"]
      }, //good
      {
        "id": 5,
        "date": "2025-03-12",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "Environmental Protection Agency",
          //Institute a pause and review of all grants.
          "story": "Halted and is re-evaluating the funding provided for various environmental projects and initiatives across the country.",
          "implications": "Terminating $20 billion in EPA grant agreements will halt and delay critical environmental protection efforts, negatively impacting public health, conservation, and the progress towards a sustainable environment.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=477"
            },
            { "name": "AP News",
                "url": "https://apnews.com/article/epa-green-bank-zeldin-climate-trump-5168d11b7f63aeaf72001b50221c3c19"
            },
          ]
        },
        "goodData": [
          {
            "verse": "Luke 12:48",
            "text": "But the one who does not know and does things deserving punishment will be beaten with few blows. From everyone who has been given much, much will be demanded; and from the one who has been entrusted with much, much more will be asked.",
            "implication": "Humanity has been given stewardship over the Earth. A wealthy and powerful nation like the US has a great responsibility to protect the environment. Pausing and terminating grants that support this responsibility is a failure to use its resources wisely and fulfill its duty as stewards."
          },
          {
            "verse": "James 2:15-16",
            "text": "Suppose a brother or a sister is without clothes and daily food. If one of you says to them, 'Go in peace; keep warm and well fed,' but does nothing about their physical needs, what good is it?",
            "implication": "Jesus calls his followers to be transparent and to let their light shine. Removing scientific advisory committees removes some of the light and transparency from the census bureau."
          },
          {
            "verse": "Luke 10:30-37",
            "text": "Parable of the Good Samaritan",
            "implication": "If the EPA grants were aimed at helping communities suffering from pollution or environmental damage, Jesus would likely see the termination as a failure to act as a 'good neighbor' and show compassion."
          }
        ],
        "tags": ["funding"]
      }, //good
    //   {
    //     "date": "2025-03-04",
    //     "subject": "Policy Change",
    //     "inEffect": true,
    //     "badData": {
    //       "department": "Commerce",
    //       "story": "Limits data collection and scientific input, hindering understanding of diverse populations.",
    //       "implications": "Limits data collection and scientific input, hindering understanding of diverse populations.",
    //       "sources": [
    //         {
    //             "name": "Project 2025",
    //             "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=715"
    //         },
    //         {
    //             "name": "Project 2025",
    //             "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=715"
    //         }
    //       ]
    //     },
    //     "goodData": [
    //       {
    //         "verse": "Matthew 22:39",
    //         "text": "...Love your neighbor as yourself.",
    //         "implication": " Accurate census data is essential for understanding and serving diverse communities. Abolishing the bureau would hinder our ability to 'love our neighbors' by addressing their specific needs."
    //       },
    //       {
    //         "verse": "Matthew 18:12-14",
    //         "text": "What do you think? If a man owns a hundred sheep, and one of them wanders away, will he not leave the ninety-nine on the hills and go to look for the one that wandered off? And if he finds it, truly I tell you, he is happier about that one sheep than about the ninety-nine that did not wander off. In the same way your Father in heaven is not willing that any of these little ones should perish.",
    //         "implication": "Jesus values every individual, especially those who are marginalized or overlooked. The census is designed to count everyone. To abolish it would be to abandon the “little ones” that Jesus cares about."
    //       },
    //       {
    //         "verse": "Luke 14:28-30",
    //         "text": "For which of you, desiring to build a tower, does not first sit down and count the cost, whether he has enough to complete it? Otherwise, when he has laid a foundation and is not able to finish, all who see it begin to mock him, saying, ‘This man began to build and was not able to finish.’",
    //         "implication": "Jesus emphasizes the importance of careful planning and accurate accounting. Abolishing the Census Bureau would be akin to building without counting the cost, leading to chaos and failure."
    //       }
    //     ],
    //     "tags": ["census"]
    //   }, //good
      {
        "id": 6,
        "date": "2025-03-04",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "Commerce",
          //"story": "Abolish non-statutory standing committees within the Census Bureau, including the Census Scientific Advisory Committee.",
          "story": "Eliminate non-legally mandated advisory boards within the Census Bureau, specifically the Census Scientific Advisory Committee.",
          "implications": "This policy removes expert scientific input from census operations, increasing the risk of politically motivated data manipulation. It weakens the accuracy and reliability of census data, which is crucial for fair resource allocation and policy decisions.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=715"
            },
            {
                "name": "AP News",
                "url": "https://apnews.com/article/census-bureau-commerce-department-howard-lutnick-3a56003b790aedce6e6c8ddd7c6b6943"
            }
          ]
        },
        "goodData": [
          {
            "verse": "John 17:17",
            "text": "Sanctify them by the truth; your word is truth.",
            "implication": "Jesus values truth as foundational. Removing scientific oversight jeopardizes the accuracy of the census, thus moving away from the truth."
          },
          {
            "verse": "Luke 16:10",
            "text": "Whoever is faithful in small matters will be faithful in large ones; whoever is dishonest in small matters will be dishonest in large ones.",
            "implication": "Accuracy in data collection is a small, but very important matter. If accuracy is not valued in the small, then it will not be valued in the large."
          },
          {
            "verse": "Philippians 4:8",
            "text": "Finally, brothers and sisters, whatever is true, whatever is noble, whatever is right, whatever is pure, whatever is lovely, whatever is admirable—if anything is excellent or praiseworthy—think about such things.",
            "implication": "Accurate, unbiased data aligns with what is true and right. Politicizing the census contradicts this principle."
          }
        ],
        "tags": ["census"]
      }, //good
      {
        "id": 7,
        "date": "2025-03-04",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "DOJ",
          //"story": "DOJ should withdraw from lawsuits seeking to uphold EMTALA abortion requirements.",
          "story": "The Department of Justice should cease its legal efforts to enforce the Emergency Medical Treatment and Active Labor Act's (EMTALA) abortion provisions.",
          "implications": "This change would allow hospitals in states with abortion restrictions to deny emergency abortion care, even when the mother's life or health is at severe risk. It prioritizes state abortion laws over federal mandates designed to protect patient safety in emergency medical situations.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=507"
            },
            {
                "name": "Politico",
                "url": "https://www.politico.com/news/2025/03/04/trump-emergency-abortions-00211399"
            }
          ]
        },
        "goodData": [
          {
            "verse": "Luke 13:10-17",
            "text": "Sanctify them by the truth; your word is truth. When Jesus saw her, he called her forward and said to her, “Woman, you are set free from your infirmity.” Then he put his hands on her, and immediately she straightened up and praised God.",
            "implication": "Jesus would save every life He could during emergency situations; he called out the hypocrites in this story who were soley focused on laws and legacy."
          },
          {
            "verse": "Mark 3:4",
            "text": "And he said to them, 'Is it lawful on the Sabbath to do good or to do harm, to save life or to kill?' But they were silent.",
            "implication": "Jesus clearly frames the choice in critical situations as being between saving life and allowing harm. A policy that permits the denial of emergency care, potentially leading to death or severe harm to the mother, would fall under the category of 'doing harm' or failing to 'save life,' which Jesus explicitly opposed."
          },
          {
            "verse": "John 8:7",
            "text": "When they kept on questioning him, he straightened up and said to them, “Let any one of you who is without sin be the first to throw a stone at her.",
            "implication": "Jesus told critical men to focus on their own sin and not obsess over the body of another."
          }
        ],
        "tags": ["reproductive health"]
      }, //good
      {
        "id": 8,
        "date": "2025-03-01",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "USDA",
          //"story": "The Department of Justice should cease its legal efforts to enforce the Emergency Medical Treatment and Active Labor Act's (EMTALA) abortion provisions.",
          "story": "Reimplement the previous administration's executive order focused on wildfire mitigation through increased vegetation reduction and expanded logging operations.",
          "implications": "This policy prioritizes active vegetation removal and logging as primary wildfire management strategies, leading to increased deforestation and environmental impacts.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=341"
            },
            {
                "name": "White House",
                "url": "https://www.whitehouse.gov/presidential-actions/2025/03/immediate-expansion-of-american-timber-production/"
            }
          ]
        },
        "goodData": [
          {
            "verse": "Matthew 6:26",
            "text": "Look at the birds of the air; they do not sow or reap or store away in barns, and yet your heavenly Father feeds them. Are you not much more valuable than they?",
            "implication": "Jesus highlights God's care for all of creation. Excessive logging could disrupt ecosystems and harm wildlife, contradicting the idea that God provides for all living things."
          },
          {
            "verse": "Revelation 11:18",
            "text": "The nations were angry, and your wrath has come. The time has come for judging the dead, and for rewarding your servants the prophets and your people who revere your name, both great and small—and for destroying those who destroy the earth.",
            "implication": "This verse suggests that God will hold accountable those who harm the earth. Excessive logging and environmental damage could be seen as actions that warrant divine judgment."
          }
        ],
        "tags": ["forest service"]
      }, //good
      {
        "id": 9,
        "date": "2025-02-28",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "Education",
          //"story": "Roll back student loan forgiveness and income-driven repayment plans.",
          "story": "Reverse the current student loan forgiveness initiatives and the implementation of income-driven repayment plans.",
          "implications": "It could negatively impact economic growth by reducing disposable income and limiting borrowers' ability to invest in housing, businesses, and other economic activities. It could heavily impact the poor, and those who are trying to better themselves.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=370"
            },
            {
                "name": "NY Times",
                "url": "https://www.nytimes.com/2025/02/28/business/student-loan-repayment-plans.html"
            }
          ]
        },
        "goodData": [
          {
            "verse": "Luke 4:18-19",
            "text": "The Spirit of the Lord is on me, because he has anointed me to proclaim good news to the poor. He has sent me to proclaim freedom for the prisoners and recovery of sight for the blind, to set the oppressed free, to proclaim the year of the Lord’s favor.",
            "implication": "Jesus's ministry focused on liberating the oppressed and bringing good news to the poor. Student loan debt often disproportionately affects low-income individuals and those struggling to escape poverty. Rolling back these programs would contradict Jesus's mission."
          },
          {
            "verse": "Matthew 25:40",
            "text": "Truly I tell you, whatever you did for one of the least of these brothers and sisters of mine, you did for me.",
            "implication": "Many student loan borrowers are among 'the least of these,' facing financial vulnerability. Jesus's teaching emphasizes caring for and helping those in need, which would be opposed by a policy that increases their financial hardship."
          }
        ],
        "tags": ["student loans"]
      }, //good
      {
        "id": 10,
        "date": "2025-02-28",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "Interior",
          //"story": "Reinstate Trump's Migratory Bird Treaty Act (companies will not be punished for killing migratory birds).",
          "story": "Reimplement the previous administration's interpretation of the Migratory Bird Treaty Act, which exempts companies from penalties for killing of migratory birds.",
          "implications": "It prioritizes industrial interests over wildlife protection and could result in a decline in migratory bird populations.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=575"
            },
            {
                "name": "Washington Post",
                "url": "https://www.washingtonpost.com/climate-environment/2025/03/10/migratory-bird-protections-suspended/"
            }
          ]
        },
        "goodData": [
          {
            "verse": "Matthew 6:26",
            "text": "Look at the birds of the air; they do not sow or reap or store away in barns, and yet your heavenly Father feeds them. Are you not much more valuable than they?",
            "implication": "Jesus highlights God's care for birds. A policy that removes protections for these creatures disregards this divine care."
          },
          {
            "verse": "Luke 12:6",
            "text": "Are not five sparrows sold for two pennies? Yet not one of them is forgotten by God.",
            "implication": "This verse underscores the value of even small creatures in God's eyes."
          }
        ],
        "tags": ["environment"]
      }, //good
      {
        "id": 11,
        "date": "2025-02-28",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "USAGM (Agency of Global Media)",
          //"story": "Dismantle USAGM's journalism "firewall" to align its reporting with the aims of the president.",
          "story": "Eliminate the USAGM's independent journalistic protections to ensure its reporting reflects the president's political objectives.",
          "implications": "This politicizes government-funded news outlets, transforming them into propaganda tools rather than sources of unbiased information.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=277"
            },
            {
                "name": "NY Times",
                "url": "https://archive.ph/tkire"
            }
          ]
        },
        "goodData": [
          {
            "verse": "John 14:6",
            "text": "Jesus answered, 'I am the way and the truth and the life. No one comes to the Father except through me.",
            "implication": "Jesus identifies himself as the embodiment of truth. Manipulating news to serve political aims contradicts this core principle."
          },
          {
            "verse": "Philippians 4:8",
            "text": "Finally, brothers and sisters, whatever is true, whatever is noble, whatever is right, whatever is pure, whatever is lovely, whatever is admirable—if anything is excellent or praiseworthy—think about such things.",
            "implication": "Jesus values truth and integrity. Politicized news, designed to manipulate rather than inform, directly opposes these virtues."
          },
          {
            "verse": "Ephesians 4:25",
            "text": "Therefore each of you must put off falsehood and speak truthfully to your neighbor, for we are all members of one body.",
            "implication": "Jesus calls for honesty and truthfulness within the community. Distorting news to align with political agendas violates this principle of truthful communication."
          }
        ],
        "tags": ["media"]
      }, //good
      {
        "id": 12,
        "date": "2025-02-27",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "Commerce",
          //"story": ""downsize" the Office of Oceanic and Atmospheric Research, which focuses too much on "climate alarmism".",
          "story": "Reduce the size and scope of the Office of Oceanic and Atmospheric Research, citing its excessive focus on climate change concerns.",
          "implications": "This policy diminishes government-funded scientific research into climate change, hindering efforts to understand and address its impacts.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=709"
            },
            {
                "name": "Axios",
                "url": "https://www.axios.com/2025/02/27/layoffs-hit-noaa-national-weather-service"
            }
          ]
        },
        "goodData": [
          {
            "verse": "Revelation 11:18",
            "text": "The nations were angry, and your wrath has come. The time has come for judging the dead, and for rewarding your servants the prophets and your people who revere your name, both great and small—and for destroying those who destroy the earth.",
            "implication": "This verse suggests divine judgment for those who harm the earth. Reducing climate change research could be seen as contributing to that harm."
          },
          {
            "verse": "Proverbs 12:10 (Quoted often by Jesus)",
            "text": "The righteous care for the needs of their animals, but the kindest acts of the wicked are cruel.",
            "implication": "Climate change poses a threat to all of creation. Reducing research that could help mitigate that threat is not an act of caring."
          }
        ],
        "tags": ["environment"]
      }, //good
      {
        "id": 13,
        "date": "2025-02-26",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "CDC (Centers for Disease Control and Prevention)",
          //"story": "End data collection on gender identity.",
          "story": "Cease the collection of data pertaining to individuals' gender identity.",
          "implications": "Erases the visibility of transgender and non-binary individuals in official statistics, hindering the ability to address their specific needs and disparities.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=489"
            },
            {
                "name": "Statnews",
                "url": "https://www.statnews.com/2025/02/25/cdc-will-no-longer-process-transgender-data/"
            }
          ]
        },
        "goodData": [
          {
            "verse": "Galatians 3:28",
            "text": "There is neither Jew nor Gentile, neither slave nor free, nor is there male and female, for you are all one in Christ Jesus.",
            "implication": "Jesus's teachings emphasize unity and equality, transcending social distinctions. Ending gender identity data collection contradicts this inclusive vision by making a group of people invisible."
          },
          {
            "verse": "Matthew 25:40",
            "text": "Truly I tell you, whatever you did for one of the least of these brothers and sisters of mine, you did for me.",
            "implication": "Transgender and non-binary individuals may face unique challenges and vulnerabilities. Ignoring their existence through data suppression disregards Jesus's call to care for the vulnerable."
          }
          ,
          {
            "verse": "1 Corinthians 12:21-22",
            "text": "The eye cannot say to the hand, 'I don’t need you!' And the head cannot say to the feet, 'I don’t need you!' On the contrary, those parts of the body that seem to be weaker are indispensable.",
            "implication": "Jesus's teachings stress the importance of every individual within the body of Christ. Ending data collection implies that the gender identities of some are unimportant, which goes against Jesus’s value of every person."
          }
        ],
        "tags": ["lgbtqia"]
      }, //good
      {
        "id": 14,
        "date": "2025-02-18",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "White House",
          //"story": "Require regulatory analysis and OIRA review...of the historically “independent” agencies.",
          "story": "Mandate regulatory impact assessments and Office of Information and Regulatory Affairs (OIRA) oversight for agencies traditionally considered independent.",
          "implications": "Increases executive branch control over agencies that were previously designed to operate with greater autonomy,  politicizing their regulatory functions.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=NaN"
            },
            {
                "name": "White House",
                "url": "https://www.whitehouse.gov/presidential-actions/2025/02/ensuring-accountability-for-all-agencies/"
            }
          ]
        },
        "goodData": [
          {
            "verse": "Luke 20:25",
            "text": "He said to them, 'Then give back to Caesar what is Caesar’s, and to God what is God’s.",
            "implication": "Jesus emphasized the importance of distinguishing between secular and divine authority. Overly centralizing control within the executive branch blurs these lines, compromising the integrity of independent agencies."
          },
          {
            "verse": "1 Timothy 5:21",
            "text": "I charge you, in the sight of God and Christ Jesus and the elect angels, to keep these instructions without partiality, and to do nothing out of favoritism.",
            "implication": "Jesus's teachings promote impartiality and fairness. Politicizing regulatory processes could lead to favoritism and bias, contradicting these principles."
          }
          ,
          {
            "verse": "John 8:32",
            "text": "Then you will know the truth, and the truth will set you free.",
            "implication": "Jesus valued truth and transparency. Increased political control over regulatory analysis could lead to biased or manipulated data, hindering the pursuit of truth."
          }
        ],
        "tags": ["presidential power"]
      }, //good
      {
        "id": 15,
        "date": "2025-02-18",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "White House",
          //"story": "Give political appointees the power to personally review and authorize appropriated funding.",
          "story": "Grant political appointees direct authority to individually approve and oversee the distribution of allocated government funds.",
          "implications": "This policy concentrates financial control within the hands of politically aligned individuals, increasing partisan bias and misuse of public funds.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=78"
            },
            {
                "name": "NPR",
                "url": "https://www.npr.org/2025/02/16/nx-s1-5297844/trump-musk-democracy-usaid-authoritarian-human-rights-funding-freeze"
            }
          ]
        },
        "goodData": [
          {
            "verse": "Luke 16:10-11",
            "text": "Whoever is faithful in small matters will be faithful in large ones; whoever is dishonest in small matters will be dishonest in large ones. So if you have not been trustworthy in handling worldly wealth, who will trust you with true riches?",
            "implication": "Jesus emphasized the importance of integrity in handling financial matters. Concentrating financial authority in the hands of political appointees increases the risk of dishonesty and misuse, which Jesus would oppose."
          },
          {
            "verse": "Luke 12:48",
            "text": "From everyone who has been given much, much will be demanded; and from the one who has been entrusted with much, much more will be asked.",
            "implication": "Jesus stressed accountability for those given power. Political appointees handling large sums of public money would have a great responsibility, and Jesus would expect them to act with utmost integrity, something that this type of policy puts at risk."
          }
          ,
          {
            "verse": "1 Timothy 6:10",
            "text": "For the love of money is a root of all kinds of evil. Some people, eager for money, have wandered from the faith and pierced themselves with many griefs.",
            "implication": "Jesus warned against the dangers of greed and the pursuit of wealth. Placing financial control in the hands of political appointees increases the opportunity for personal gain, which Jesus would oppose."
          }
        ],
        "tags": ["presidential power"]
      }, //good
      {
        "id": 16,
        "date": "2025-02-14",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "EPA",
          //"story": "Downsize the department by terminating newest hires and relocating career employees to other agencies.",
          "story": "Reduce the department's workforce through the termination of recently hired employees and the reassignment of long-term staff to different agencies.",
          "implications": "This policy prioritizes short-term cost reduction over long-term institutional knowledge and employee stability, disrupting departmental operations and harming employee morale.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=455"
            },
            {
                "name": "The Hill",
                "url": "https://thehill.com/policy/energy-environment/5146618-epa-fires-employees-500-probationary/"
            }
          ]
        },
        "goodData": [
          {
            "verse": "Philippians 2:3-4",
            "text": "Do nothing out of selfish ambition or vain conceit. Rather, in humility value others above yourselves, not looking to your own interests but each of you to the interests of the others.",
            "implication": "Jesus's teachings emphasize humility and prioritizing the well-being of others. A policy that disrupts the lives of employees for the sake of departmental downsizing lacks this humility and concern for others."
          },
          {
            "verse": "James 5:4",
            "text": "Look! The wages you failed to pay the workers who mowed your fields are crying out against you. The cries of the harvesters have reached the ears of the Lord Almighty.",
            "implication": "The Bible talks of the importance of paying fair wages, and treating workers fairly. The actions of terminating and relocating employees, if not done fairly, would be something that Jesus would oppose."
          }
          ,
          {
            "verse": "Luke 10:7",
            "text": "Stay there, eating and drinking whatever they give you, for the worker deserves their wages. Do not move from house to house.",
            "implication": "This verse reinforces the idea that workers deserve fair treatment and compensation. Relocating career employees against their will, and terminating new people, could be seen as unjust treatment."
          }
        ],
        "tags": ["environment", "government"]
      }, //good
      {
        "id": 17,
        "date": "2025-02-12",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "DOJ",
          //"story": "Take the position that Humphrey's Executor violates the separation of powers.",
          "story": "Argue that the Supreme Court ruling in Humphrey's Executor v. United States, which restricted the president's power to remove leaders of independent agencies, infringes upon the principle of separation of powers.",
          "implications": "Increases the executive branch's influence over regulatory bodies, which could lead to increased politicization of regulation and a weakening of agency independence.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=593"
            },
            {
                "name": "MSNBC",
                "url": "https://www.msnbc.com/deadline-white-house/deadline-legal-blog/humphreys-executor-doj-supreme-court-federal-agencies-rcna192041"
            }
          ]
        },
        "goodData": [
          {
            "verse": "John 18:36",
            "text": "Jesus said, 'My kingdom is not of this world. If it were, my servants would fight to prevent my arrest by the Jewish leaders. But now my kingdom is from another place.'",
            "implication": "Jesus distinguished between earthly and spiritual authority. A policy that seeks to increase earthly power, by a single person, goes against the idea of a different, and higher, kingdom."
          },
          {
            "verse": "Luke 20:25",
            "text": "He said to them, 'Then give back to Caesar what is Caesar’s, and to God what is God’s.",
            "implication": "Jesus recognized the need for distinct spheres of authority. Overly concentrating power in the executive branch blurs these boundaries, contradicting this principle."
          }
          ,
          {
            "verse": "Micah 6:8",
            "text": "He has shown you, O mortal, what is good. And what does the Lord require of you? To act justly and to love mercy and to walk humbly with your God.",
            "implication": "Jesus valued justice and humility. Overly empowering one branch of government, risks the decrease of just actions, and increases the risk of prideful ones."
          }
        ],
        "tags": ["presidential power"]
      }, //good
      {
        "id": 18,
        "date": "2025-02-11",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "Securities and Exchange Commission",
          //"story": "Rescind the SEC's climate disclosure rule.",
          "story": "The Securities and Exchange Commission (SEC) will withdraw its regulation requiring publicly traded companies to disclose climate-related risks and emissions.",
          "implications": "Reduces ttransparency regarding corporate environmental impacts, hindering investor awareness and accountability for climate-related financial risks.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=865"
            },
            {
                "name": "SEC",
                "url": "https://www.sec.gov/newsroom/speeches-statements/uyeda-statement-climate-change-021025"
            }
          ]
        },
        "goodData": [
          {
            "verse": "John 3:21",
            "text": "But whoever lives by the truth comes into the light, so that it may be seen plainly that what they have done has been done in the sight of God.",
            "implication": "Jesus values transparency and truthfulness. Rescinding climate disclosure rules obscures information, hindering the ability to act truthfully."
          },
          {
            "verse": "Matthew 25:45",
            "text": "He will reply, ‘Truly I tell you, whatever you did not do for one of the least of these, you did not do for me.’",
            "implication": "The effects of climate change disproportionately impact vulnerable populations. Rescinding rules that could help protect those populations, goes against Jesus’s teachings."
          }
          ,
          {
            "verse": "James 5:1-3",
            "text": "Now listen, you rich people, weep and wail because of the misery that is coming on you. Your wealth has rotted, and moths have eaten your clothes. Your gold and silver are corroded. Their corrosion will testify against you and eat your flesh like fire. You have hoarded wealth in the last days.",
            "implication": "This passage warns against prioritizing wealth over ethical conduct and the well being of others. Hiding climate impacts, for the sake of profit, goes against this warning."
          }
        ],
        "tags": ["economy", "environment"]
      }, //good
      {
        "id": 19,
        "date": "2025-02-08",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "Homeland Security",
          //"story": "Authorize state and local law enforcement to participate in immigration actions.",
          "story": "Grant state and local law enforcement agencies the authority to engage in federal immigration enforcement activities, including the detention and interrogation of suspected undocumented immigrants.",
          "implications": "Blurs the lines between local law enforcement and federal immigration authorities, leading to racial profiling and the erosion of trust between immigrant communities and local police.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=183"
            },
            {
                "name": "ABC",
                "url": "https://abcnews.go.com/US/wireStory/trump-signing-local-law-officers-immigration-enforcement-118598342"
            }
          ]
        },
        "goodData": [
          {
            "verse": "Matthew 25:35-40",
            "text": "For I was hungry and you gave me something to eat, I was thirsty and you gave me something to drink, I was a stranger and you invited me in, I needed clothes and you clothed me, I was sick and you looked after me, I was in prison and you came to visit me...Truly I tell you, whatever you did for one of the least of these brothers and sisters of mine, you did for me.",
            "implication": "Jesus identifies with those who are marginalized and in need, including 'strangers'. A policy that authorizes local law enforcement to detain and interrogate immigrants would likely be seen as contrary to Jesus's call to care for the vulnerable."
          },
          {
            "verse": "James 2:13",
            "text": "...because judgment without mercy will be shown to anyone who has not been merciful. Mercy triumphs over judgment.",
            "implication": "Jesus emphasized mercy and compassion. Policies that prioritize detention and interrogation over humane treatment would be seen as lacking mercy and therefore opposed by Jesus."
          }
          ,
          {
            "verse": "Romans 12:18",
            "text": "If it is possible, as far as it depends on you, live at peace with everyone.",
            "implication": "Jesus values peace and reconciliation. Policies that create fear and division within communities, such as those that authorize local law enforcement to engage in immigration actions, would likely be opposed."
          }
        ],
        "tags": ["immigration"]
      }, //good
      {
        "id": 20,
        "date": "2025-02-06",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "Environmental Protection Agency",
          //"story": "Eliminate the Office of Environmental Justice and External Civil Rights.",
          "story": "Abolish the Office of Environmental Justice and External Civil Rights.",
          "implications": "Removes a federal entity dedicated to addressing environmental disparities and civil rights violations, leaving vulnerable communities without crucial protections.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=454"
            },
            {
                "name": "NPR",
                "url": "https://www.npr.org/2025/02/06/nx-s1-5289331/epa-employees-who-work-on-environmental-justice-are-put-on-leave"
            }
          ]
        },
        "goodData": [
          {
            "verse": "Luke 4:18-19",
            "text": "The Spirit of the Lord is on me, because he has anointed me to proclaim good news to the poor. He has sent me to proclaim freedom for the prisoners and recovery of sight for the blind, to set the oppressed free, to proclaim the year of the Lord’s favor.",
            "implication": "Jesus's ministry was centered on bringing justice and liberation to the marginalized. Eliminating an office that protects vulnerable populations directly opposes his mission."
          },
          {
            "verse": "Matthew 25:40",
            "text": "Truly I tell you, whatever you did for one of the least of these brothers and sisters of mine, you did for me.",
            "implication": "Environmental justice and civil rights protections often benefit 'the least of these.' Removing these protections disregards Jesus's call to care for the vulnerable."
          }
          ,
          {
            "verse": "Micah 6:8",
            "text": "He has shown you, O mortal, what is good. And what does the Lord require of you? To act justly and to love mercy and to walk humbly with your God.",
            "implication": "Jesus values justice and mercy. Eliminating an office designed to ensure these principles are upheld is unjust and unmerciful."
          }
        ],
        "tags": ["reorganization"]
      }, //good
      {
        "id": 21,
        "date": "2025-02-05",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "Department of Justice",
          //"story": "Use "the full force of federal prosecutorial resources" to investigate and prosecute state and local gov'ts, institutes of higher ed, corporations, and private employers who have",
          "story": "Direct federal prosecutors to aggressively investigate and pursue legal action against state and local governments, universities, businesses, and private employers that implement diversity-focused programs.",
          "implications": "Weaponizes federal law enforcement against diversity initiatives, halting efforts to promote inclusion and equity within various sectors of society.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=454"
            },
            {
                "name": "NPR",
                "url": "https://www.npr.org/2025/02/06/nx-s1-5289331/epa-employees-who-work-on-environmental-justice-are-put-on-leave"
            }
          ]
        },
        "goodData": [
            {
                "verse": "Galatians 3:28",
                "text": "There is neither Jew nor Gentile, neither slave nor free, nor is there male and female, for you are all one in Christ Jesus.",
                "implication": "Jesus's teachings, as reflected in this verse, emphasize unity and equality, transcending social distinctions. A policy that targets diversity initiatives directly contradicts this principle of oneness."
              },
              {
                "verse": "Matthew 22:39",
                "text": "And the second is like it: ‘You shall love your neighbor as yourself.",
                "implication": "Jesus's call to love one's neighbor implies valuing and respecting individuals from all backgrounds. To actively prosecute programs that promote diversity is the opposite of showing love to ones neighbor."
              }
              ,
              {
                "verse": "James 2:1-9",
                "text": "This passage condemns showing favoritism to the rich and powerful while disregarding the poor and marginalized.",
                "implication": "Diversity initiatives often seek to level the playing field. Using federal prosecutorial resources to dismantle these programs would be seen as favoring those who already hold positions of power, which Jesus would oppose."
              }
        ],
        "tags": ["dei"]
      }, //good data
      {
        "id": 22,
        "date": "2025-02-05",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "Department of Justice",
          //"story": "Withdraw funding for United Nations Relief and Works Agency.",
          "story": "Terminate financial support for the United Nations Relief and Works Agency (UNRWA).",
          "implications": "Cuts off essential humanitarian aid to Palestinian refugees, exacerbating their already dire living conditions.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=224"
            },
            {
                "name": "Reuters",
                "url": "https://www.reuters.com/world/us/trump-signs-orders-iran-withdrawing-us-un-human-rights-council-unrwa-2025-02-04/"
            }
          ]
        },
        "goodData": [
            {
                "verse": "James 2:15-16",
                "text": "Suppose a brother or a sister is without clothes and daily food. If one of you says to them, ‘Go in peace; keep warm and well fed,’ but does nothing about their physical needs, what good is it?",
                "implication": "Jesus values action over mere words. Withdrawing funding that provides essential resources to refugees contradicts this principle of tangible aid."
              },
              {
                "verse": "1 John 3:17",
                "text": "If anyone has material possessions and sees a brother or sister in need but has no pity on them, how can the love of God be in that person?",
                "implication": "Jesus calls for compassion and generosity toward those in need. Withholding aid from refugees demonstrates a lack of pity, which contradicts the love of God."
              }
              ,
              {
                "verse": "Matthew 25:40",
                "text": "Truly I tell you, whatever you did for one of the least of these brothers and sisters of mine, you did for me.",
                "implication": "Jesus identifies with those in need. Palestinian refugees, often living in poverty and hardship, are among the 'least of these.' Withholding aid contradicts Jesus's call to care for them."
              }
        ],
        "tags": ["aid"]
      }, //good
      {
        "id": 23,
        "date": "2025-02-05",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "USAID",
          //"story": "Withdraw funding for United Nations Relief and Works Agency.",
          "story": "Directly allocate government funds with a preference towards organizations that are explicitly faith-based.",
          "implications": "This action violates the separation of church and state, and discriminates against potentially more efficient secular organizations providing similar services.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=298"
            },
            {
                "name": "Ministry Watch",
                "url": "https://ministrywatch.com/samaritans-purse-dodges-trumps-foreign-aid-freeze/"
            }
          ]
        },
        "goodData": [
            {
                "verse": "Matthew 6:1-4",
                "text": "Be careful not to practice your righteousness in front of others to be seen by them. If you do, you will have no reward from your Father in heaven. So when you give to the needy, do not announce it with trumpets, as the hypocrites do in the synagogues and on the streets, to be honored by others. Truly I tell you, they have received their reward in full. But when you give to the needy, do not let your left hand know what your right hand is doing, so that your giving may be in secret. Then your Father, who sees what is done in secret, will reward you.",
                "implication": "Jesus emphasized private acts of charity rather than public displays of piety. Prioritizing faith-based organizations for funding could incentivize public displays of faith for financial gain, contradicting Jesus's teaching."
              },
              {
                "verse": "John 18:36",
                "text": "Jesus said, 'My kingdom is not of this world. If it were, my servants would fight to prevent my arrest by the Jewish leaders. But now my kingdom is from another place.",
                "implication": "Jesus's kingdom is not based on worldly power or government support. Prioritizing faith-based organizations for funding could entangle religious institutions with secular power, which Jesus would oppose."
              }
              ,
              {
                "verse": "Matthew 22:21",
                "text": "They said to him, 'Caesar’s.' Then he said to them, 'Therefore render to Caesar the things that are Caesar’s, and to God the things that are God’s.",
                "implication": "Jesus distinguished between secular and religious realms. Using government funds to exclusively favor faith-based organizations blurs this distinction."
              }
        ],
        "tags": ["aid"]
      }, //good
      {
        "id": 24,
        "date": "2025-02-03",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "State",
          //"story": "Withdraw from the United Nations Human Rights Council.",
          "story": "Terminate the United States' membership and participation in the United Nations Human Rights Council.",
          "implications": "Removes the United States' voice and influence from international efforts to address human rights abuses, weakening global human rights protections.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=224"
            },
            {
                "name": "Politico",
                "url": "https://www.politico.com/news/2025/02/03/us-withdraw-un-human-rights-council-trump-00202100"
            }
          ]
        },
        "goodData": [
            {
                "verse": "Luke 4:18-19",
                "text": "The Spirit of the Lord is on me, because he has anointed me to proclaim good news to the poor. He has sent me to proclaim freedom for the prisoners and recovery of sight for the blind, to set the oppressed free, to proclaim the year of the Lord’s favor.",
                "implication": "Jesus's ministry was centered on liberating the oppressed and advocating for justice. The UN Human Rights Council plays a role in addressing oppression globally. To abandon that role, is to abandon Jesus's mission."
              },
              {
                "verse": "Philippians 2:4",
                "text": "not looking to your own interests but each of you to the interests of the others.",
                "implication": "Jesus urges us to consider the well-being of others, especially those facing hardship. Withdrawing from the UN Human Rights Council prioritizes national interests over the needs of those suffering human rights abuses."
              }
              ,
              {
                "verse": "Micah 6:8",
                "text": "He has shown you, O mortal, what is good. And what does the Lord require of you? To act justly and to love mercy and to walk humbly with your God.",
                "implication": "Jesus calls for justice and mercy. The UN Human Rights Council is a forum for addressing injustices. Withdrawing from it undermines the pursuit of these values."
              }
        ],
        "tags": ["aid"]
      }, //good
      {
        "id": 25,
        "date": "2025-02-03",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "EPA",
          //"story": "Stop all grants to "advocacy groups.",
          "story": "Terminate all federal grant funding to organizations engaged in advocacy activities.",
          "implications": "Removes financial support for a wide range of organizations working on issues such as environmental protection, social justice, and public education, hindering their ability to operate and advocate for their causes.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=455"
            },
            {
                "name": "Waste Dive",
                "url": "https://www.wastedive.com/news/federal-funding-pause-confusion-hits-environmental-program-funding/738993/"
            }
          ]
        },
        "goodData": [
            {
                "verse": "James 2:15-16",
                "text": "Suppose a brother or a sister is without clothes and daily food. If one of you says to them, ‘Go in peace; keep warm and well fed,’ but does nothing about their physical needs, what good is it?",
                "implication": "Jesus values action over mere words. Cutting funding that provides tangible support to those in need contradicts this principle."
              },
              {
                "verse": "Matthew 25:40",
                "text": "Truly I tell you, whatever you did for one of the least of these brothers and sisters of mine, you did for me.",
                "implication": "Many advocacy groups work to support marginalized and vulnerable populations. Cutting off their funding disregards Jesus's call to care for 'the least of these.'"
              }
              ,
              {
                "verse": "Luke 4:18-19",
                "text": "The Spirit of the Lord is on me, because he has anointed me to proclaim good news to the poor. He has sent me to proclaim freedom for the prisoners and recovery of sight for the blind, to set the oppressed free, to proclaim the year of the Lord’s favor.",
                "implication": "Jesus's ministry was centered on advocating for the oppressed and marginalized. Eliminating funding for groups that do the same contradicts his mission."
              }
        ],
        "tags": ["funding"]
      }, //good
      {
        "id": 26,
        "date": "2025-02-03",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "USAID",
          //"story": "Cut budget of USAID.",
          "story": "Reduce the United States Agency for International Development's (USAID) funding to zero, effectively dismantling the agency.",
          "implications": "Eliminates U.S. foreign aid programs, destabilizing vulnerable nations and reducing access to essential humanitarian assistance and development initiatives.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=287"
            },
            {
                "name": "NPR",
                "url": "https://www.npr.org/2025/02/03/nx-s1-5285409/usaid-trump-state-department-rubio"
            },
            {
                "name": "Forbes",
                "url": "https://www.forbes.com/sites/jenniferlotito/2025/03/05/usaid-dismantling-disrupt-us-workforce/"
            },
            {
                "name": "KUOW",
                "url": "https://www.kuow.org/stories/pete-marocco-tried-to-upend-usaid-in-2020-and-failed-in-2025-he-dismantled-it"
            }
          ]
        },
        "goodData": [
            {
                "verse": "Matthew 25:40",
                "text": "Truly I tell you, whatever you did for one of the least of these brothers and sisters of mine, you did for me.",
                "implication": "USAID provides assistance to many of 'the least of these' around the world. Cutting its budget disregards Jesus's call to care for the vulnerable."
              },
              {
                "verse": "1 John 3:17",
                "text": "If anyone has material possessions and sees a brother or sister in need but has no pity on them, how can the love of God be in that person?",
                "implication": "Jesus calls for compassion and generosity toward those in need. Withholding aid from those suffering demonstrates a lack of pity, which contradicts the love of God."
              }
              ,
              {
                "verse": "James 2:15-16",
                "text": "Suppose a brother or a sister is without clothes and daily food. If one of you says to them, ‘Go in peace; keep warm and well fed,’ but does nothing about their physical needs, what good is it?",
                "implication": "Jesus values action over mere words. Cutting funding that provides essential resources to those in need contradicts this principle."
              }
        ],
        "tags": ["aid"]
      }, //good
      {
        "id": 27,
        "date": "2025-02-03",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "United States Agency for International Development",
          //"story": "Rescind USAID policies that address climate change and help countries transition away from fossil fuels.",
          "story": "Eliminate all funding for the United States Agency for International Development (USAID), initiating its complete closure.",
          "implications": "Terminates all U.S. government-supported international aid programs, severely impacting global health, economic development, and humanitarian relief efforts.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=290"
            },
            {
                "name": "NPR",
                "url": "https://www.npr.org/2025/02/03/nx-s1-5285409/usaid-trump-state-department-rubio"
            },
            {
                "name": "Forbes",
                "url": "https://www.forbes.com/sites/jenniferlotito/2025/03/05/usaid-dismantling-disrupt-us-workforce/"
            },
            {
                "name": "UMNews",
                "url": "https://www.umnews.org/en/news/church-grapples-with-loss-of-foreign-aid"
            }
          ]
        },
        "goodData": [
            {
                "verse": "Luke 12:48",
                "text": "From everyone who has been given much, much will be demanded; and from the one who has been entrusted with much, much more will be asked.",
                "implication": "The U.S., as a wealthy nation, has been 'given much.' Jesus's teaching implies a responsibility to use those resources wisely and generously, which USAID aims to do. To remove this giving, would be to ignore that responsibility."
              },
            {
                "verse": "Matthew 25:35-36",
                "text": "For I was hungry and you gave me something to eat, I was thirsty and you gave me something to drink, I was a stranger and you invited me in, I needed clothes and you clothed me, I was sick and you looked after me, I was in prison and you came to visit me.",
                "implication": "Jesus directly addresses the importance of providing for the basic needs of others. USAID's work often addresses these very needs on a global scale, and to cut it would be to not provide for those in need."
              },
              {
                "verse": "Luke 6:35",
                "text": "But love your enemies, do good to them, and lend to them without expecting to get anything back. Then your reward will be great, and you will be children of the Most High, because he is kind to the ungrateful and wicked.",
                "implication": "Jesus emphasizes unconditional generosity. USAID's programs often extend aid to nations and people who may not be considered allies. Cutting such aid contradicts this principle of selfless giving."
              }
              
        ],
        "tags": ["aid"]
      }, //good
      {
        "id": 28,
        "date": "2025-02-03",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "United States Agency for International Development",
          //"story": "Cut International Disaster Assistance funding for programs in Yemen, Syria, and Afghanistan.",
          "story": "Eliminate International Disaster Assistance funding specifically for programs operating within Yemen, Syria, and Afghanistan.",
          "implications": "Immediately deprive millions of people in these war-torn and disaster-stricken nations of life-saving humanitarian aid, exacerbating existing crises and leading to increased suffering and mortality.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=301"
            },
            {
                "name": "NPR",
                "url": "https://www.npr.org/2025/02/03/nx-s1-5285409/usaid-trump-state-department-rubio"
            },
            {
                "name": "Forbes",
                "url": "https://www.forbes.com/sites/jenniferlotito/2025/03/05/usaid-dismantling-disrupt-us-workforce/"
            },
            {
                "name": "UMNews",
                "url": "https://www.umnews.org/en/news/church-grapples-with-loss-of-foreign-aid"
            }
          ]
        },
        "goodData": [
            {
                "verse": "1 John 3:17",
                "text": "If anyone has material possessions and sees a brother or sister in need but has no pity on them, how can the love of God be in that person?",
                "implication": "Jesus calls for active compassion. Withholding aid from those facing starvation and devastation demonstrates a lack of pity, contradicting the love of God."
              },
            {
                "verse": "Matthew 25:45",
                "text": "He will reply, ‘Truly I tell you, whatever you did not do for one of the least of these, you did not do for me.’",
                "implication": "The people of Yemen, Syria, and Afghanistan, facing famine, war, and natural disasters, are among the most vulnerable. Withholding aid directly contradicts Jesus's identification with those in dire need."
              },
            {
                "verse": "James 2:15-16",
                "text": "Suppose a brother or a sister is without clothes and daily food. If one of you says to them, ‘Go in peace; keep warm and well fed,’ but does nothing about their physical needs, what good is it?",
                "implication": "Jesus values tangible acts of compassion. Merely expressing sympathy without providing material assistance is meaningless. Cutting off aid denies people essential resources for survival."
              }
        ],
        "tags": ["aid"]
      }, //good
      {
        "id": 29,
        "date": "2025-02-03",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "United States Agency for International Development",
          //"story": "Prohibit USAID from funding "sexual reproductive health and reproductive rights" and "gender equality" programs.",
          "story": "Deny access to essential healthcare services and programs promoting gender equality for women and girls in developing countries, leading to increased health risks and gender-based disparities.",
          "implications": "Immediately deprive millions of people in these war-torn and disaster-stricken nations of life-saving humanitarian aid, exacerbating existing crises and leading to increased suffering and mortality.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=301"
            },
            {
                "name": "NPR",
                "url": "https://www.npr.org/2025/02/03/nx-s1-5285409/usaid-trump-state-department-rubio"
            },
            {
                "name": "Forbes",
                "url": "https://www.forbes.com/sites/jenniferlotito/2025/03/05/usaid-dismantling-disrupt-us-workforce/"
            }
          ]
        },
        "goodData": [
            {
                "verse": "Galatians 3:28",
                "text": "There is neither Jew nor Gentile, neither slave nor free, nor is there male and female, for you are all one in Christ Jesus.",
                "implication": "This verse emphasizes equality and unity in Christ. A policy that perpetuates gender inequality contradicts this principle."
              },
            {
                "verse": "Luke 13:10-17",
                "text": "In this passage, Jesus heals a woman who had been crippled for 18 years, and rebukes those who were upset that he healed on the sabbath.",
                "implication": "Jesus prioritized healing and compassion over rigid adherence to rules. Denying women access to healthcare, and bodily autonomy, would go against this."
              },
            {
                "verse": "Mark 10:6-9",
                "text": "But at the beginning of creation God ‘made them male and female.’ ‘For this reason a man will leave his father and mother and be united to his wife, and the two will become one flesh.’ So they are no longer two, but one flesh. Therefore what God has joined together, let no one separate.",
                "implication": "Jesus reaffirmed the creation of male and female, and the importance of their union. Denying women reproductive rights, is to deny their ability to control their own bodies, and therefore the creation that god made."
              }
        ],
        "tags": ["aid", "reproductive health"]
      }, //good
      {
        "id": 30,
        "date": "2025-01-31",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "Department of Education",
          //"story": "Rescind Biden-era Title IX rules that strengthened the proseuction of sexual assault and discrimination claims.",
          "story": "Revoke the Biden administration's Title IX regulations that expanded protections and enforcement regarding sexual assault and discrimination in educational settings.",
          "implications": "Weakens legal protections for students against sexual assault and discrimination, creating a less safe and equitable educational environment.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=366"
            },
            {
                "name": "The Hill",
                "url": "https://thehill.com/homenews/education/5118925-trump-biden-title-ix-education-gender-lgbtq/"
            },
            // {
            //     "name": "Forbes",
            //     "url": "https://www.forbes.com/sites/jenniferlotito/2025/03/05/usaid-dismantling-disrupt-us-workforce/"
            // }
          ]
        },
        "goodData": [
            {
                "verse": "Matthew 25:40",
                "text": "Truly I tell you, whatever you did for one of the least of these brothers and sisters of mine, you did for me.",
                "implication": "Victims of sexual assault and discrimination are often among the most vulnerable. Weakening their legal protections disregards Jesus's call to care for 'the least of these.'"
              },
            {
                "verse": "Matthew 5:9",
                "text": "Blessed are the peacemakers, for they will be called children of God.",
                "implication": "Jesus values peace and safety. Rescinding rules that protect people from assault and discrimination, removes peace and safety from their lives."
              },
            {
                "verse": "Luke 10:29-37",
                "text": "This parable emphasizes compassion and aid for those who are suffering and in need",
                "implication": "Jesus's parable demonstrates the importance of protecting those who are vulnerable to harm. Rescinding Title IX protections removes a layer of safety from those in need."
              }
        ],
        "tags": ["civil rights", "dei"]
      }, //good
      {
        "id": 31,
        "date": "2025-01-31",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "White House",
          //"story": "Remove the words "sexual orientation and gender identity," "diversity, equity, and inclusion," "abortion," "reproductive health," and "gender equality" from every federal rule, and agency regulation, that exists.",
          "story": "Systematically eliminate all references to 'sexual orientation and gender identity,' 'diversity, equity, and inclusion,' 'abortion,' 'reproductive health,' and 'gender equality' from all existing federal rules and agency regulations.",
          "implications": "Erase legal recognition and protections for LGBTQ+ individuals, women, and marginalized groups, leading to increased discrimination and inequality across federal programs and services.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=37"
            },
            {
                "name": "AP News",
                "url": "https://apnews.com/article/trump-gender-ideology-sex-pronouns-order-transgender-2d7e54837f5d0651ed0cefa5ea0d6301"
            },
            // {
            //     "name": "Forbes",
            //     "url": "https://www.forbes.com/sites/jenniferlotito/2025/03/05/usaid-dismantling-disrupt-us-workforce/"
            // }
          ]
        },
        "goodData": [
            {
                "verse": "John 13:34-35",
                "text": "A new command I give you: Love one another. As I have loved you, so you must love one another. By this everyone will know that you are my disciples, if you love one another.",
                "implication": "Jesus's core message is one of love and inclusion. Erasing language that acknowledges diverse identities and promotes equality directly contradicts this command to love all people."
              },
            {
                "verse": "Romans 12:10",
                "text": "Be devoted to one another in love. Honor one another above yourselves.",
                "implication": "This verse calls for mutual respect and honor. Removing language that affirms the dignity of marginalized groups disregards this call to honor all people."
              },
            {
                "verse": "1 Corinthians 12:25-26",
                "text": "So that there should be no division in the body, but that its parts should have equal concern for each other. If one part suffers, every part suffers with it; if one part is honored, every part rejoices with it.",
                "implication": "This passage emphasizes the interconnectedness of the human community. Removing protections for vulnerable groups creates division and suffering, which Jesus would oppose."
              }
        ],
        "tags": ["dei", "lgbtqia"]
      }, //good
      {
        "id": 32,
        "date": "2025-01-30",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "Education",
          //"story": "Ban "critical race theory" and "gender ideology" from public school curriculum.",
          "story": "Prohibit the inclusion of critical race theory and gender ideology concepts within public school educational curricula.",
          "implications": "Restrict the teaching of historical and social analyses related to systemic racism and gender identity, limiting students' understanding of complex societal issues; in effect, lying.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=37"
            },
            {
                "name": "AP News",
                "url": "https://apnews.com/article/trump-gender-ideology-sex-pronouns-order-transgender-2d7e54837f5d0651ed0cefa5ea0d6301"
            },
            {
                "name": "White House",
                "url": "https://www.whitehouse.gov/presidential-actions/2025/01/ending-radical-indoctrination-in-k-12-schooling/"
            },
            {
                "name": "NY Times",
                "url": "https://www.nytimes.com/2025/01/29/us/politics/trump-executive-orders-schools-antisemitism-race-gender.html"
            }
          ]
        },
        "goodData": [
            {
                "verse": "Luke 4:18-19",
                "text": "The Spirit of the Lord is on me, because he has anointed me to proclaim good news to the poor. He has sent me to proclaim freedom for the prisoners and recovery of sight for the blind, to set the oppressed free, to proclaim the year of the Lord’s favor.",
                "implication": "Jesus's ministry centered on liberating the oppressed and bringing sight to the blind. Excluding discussions of systemic oppression from education contradicts this mission."
              },
            {
                "verse": "Ephesians 4:15",
                "text": "Instead, speaking the truth in love, we will grow to become in every respect the mature body of him who is the head, that is, Christ.",
                "implication": "Jesus calls for truthful dialogue, even when it's difficult. Banning discussions of sensitive topics like race and gender hinders the ability to speak truth in love, which is vital for spiritual growth."
              },
            {
                "verse": "Galatians 3:28",
                "text": "There is neither Jew nor Gentile, neither slave nor free, nor is there male and female, for you are all one in Christ Jesus.",
                "implication": "This verse emphasizes equality and unity in Christ. Banning discussions of gender identity and systemic inequality directly undermines this principle of oneness."
              }
        ],
        "tags": ["equality", "lgbtqia"]
      }, //good
      {
        "id": 33,
        "date": "2025-01-29",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "Education",
          //"story": "Expand school choice (i.e. public funding for private schools).",
          "story": "Implemented a policy of publicly funding private education to expand school choice.",
          "implications": "Significantly reduces funding for public schools, leading to a decline in resources and quality of education for the majority of students who depend on the public system.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=383"
            },
            {
                "name": "Peer",
                "url": "https://peerforeducation.org/wp-content/uploads/2025/03/PEER_StateofVouchers.pdf"
            },
            {
                "name": "White House",
                "url": "https://www.whitehouse.gov/presidential-actions/2025/01/expanding-educational-freedom-and-opportunity-for-families/"
            },
            {
                "name": "First Focus",
                "url": "https://firstfocus.org/resource/school-vouchers-issue-brief/"
            }
          ]
        },
        "goodData": [
            {
                "verse": "Luke 4:18",
                "text": "The Spirit of the Lord is on me, because he has anointed me to proclaim good news to the poor. He has sent me to proclaim freedom for the prisoners and recovery of sight for the blind, to set the oppressed free.",
                "implication": "Jesus' mission was centered on serving the poor and marginalized."
              },
            {
                "verse": "Matthew 19:14",
                "text": "But Jesus said, 'Let the little children come to me, and do not hinder them, for the kingdom of heaven belongs to such as these.'",
                "implication": "Jesus welcomed all children without reservation. A system that could create disparities in educational opportunities based on financial means might be seen as hindering some children's access to quality education, conflicting with Jesus' inclusive approach."
              },
            {
                "verse": "Matthew 6:24",
                "text": "No one can serve two masters. Either you will hate the one and love the other, or you will be devoted to the one and despise the other. You cannot serve both God and money.",
                "implication": "This verse highlights the potential conflict between prioritizing financial gain and serving others. It benefits private entities financially at the expense of the public good and equitable access to education, seen as serving 'money' over the well-being of all children, which Jesus might oppose."
              }
        ],
        "tags": ["education"]
      }, //good
      {
        "id": 34,
        "date": "2025-01-29",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "Transportation",
          //"story": "Reduce fuel economy requirements. Note: Transportation Secretary ordered the department to reverse Biden-era fuel economy standards.",
          "story": "Transportation Secretary directed the department of transportation to reduce fuel economy requirements.",
          "implications": "Weakening fuel economy standards will lead to increased greenhouse gas emissions, exacerbating climate change and its associated negative impacts on the environment and public health.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=383"
            },
            {
                "name": "UCS",
                "url": "https://blog.ucs.org/don-anair/rolling-back-vehicle-standards-is-bad-for-drivers-the-auto-industry-and-anything-that-breathes/"
            },
            {
                "name": "Sierra Club",
                "url": "https://www.sierraclub.org/press-releases/2025/03/sean-duffy-seeks-make-vehicles-less-efficient-more-expensive"
            }
          ]
        },
        "goodData": [
            {
                "verse": "Revelation 11:18",
                "text": "...and will destroy those who destroy the earth.",
                "implication": "Reflects a divine concern for the well-being of the planet."
              },
            {
                "verse": "Luke 12:48",
                "text": "...From everyone who has been given much, much will be demanded; and from the one who has been entrusted with much, much more will be asked.",
                "implication": "Developed nations, including the United States, have historically contributed significantly to greenhouse gas emissions. Reducing fuel economy standards should be interpreted as a failure to take responsibility for this impact."
              },
            {
                "verse": "James 4:17",
                "text": "So whoever knows the right thing to do and fails to do it, for him it is sin.",
                "implication": "Given the scientific consensus on the negative impacts of greenhouse gas emissions and the role of fuel efficiency in reducing them, choosing to weaken fuel economy standards could be seen as a failure to do the 'right thing.'"
              }
        ],
        "tags": ["transportation"]
      }, //good
      {
        "id": 35,
        "date": "2025-01-28",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "Defense",
          //"story": "Abolish DEI offices in the Defense Dept. and military.",
          "story": "Abolishment of Diversity, Equity, and Inclusion offices in the Defense Department and across the military.",
          "implications": "Eliminating DEI offices undermines efforts to foster a more diverse, equitable, and inclusive military, harming morale, recruitment, and the overall effectiveness of the armed forces in a diverse society.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=136"
            },
            {
                "name": "Newsweek",
                "url": "https://www.newsweek.com/dei-diversity-donald-trump-removals-content-jackie-robinson-2049534"
            },
            {
                "name": "NPR",
                "url": "https://www.npr.org/2025/01/28/nx-s1-5276839/trump-executive-order-dei-military"
            }
          ]
        },
        "goodData": [
            {
                "verse": "James 2:1-4",
                "text": "...believers in our glorious Lord Jesus Christ, don’t show favoritism. Suppose a man comes into your meeting wearing a gold ring and fine clothes, and a poor man in shabby clothes also comes in. If you show special attention to the man wearing fine clothes and say, “Here’s a good seat for you,” while you say to the poor man, “You stand there” or “Sit on the floor by my feet,” have you not discriminated among yourselves and become judges with evil thoughts?",
                "implication": "Condemns showing favoritism based on social status."
              },
            {
                "verse": "Luke 14:12-14",
                "text": "Then Jesus said to his host ...when you give a banquet, invite the poor, the crippled, the lame, the blind, and you will be blessed. Although they cannot repay you, you will be repaid at the resurrection of the righteous.",
                "implication": "Jesus advocated for inclusivity and prioritizing those often marginalized by society. DEI initiatives in the military aim to create a more inclusive environment for individuals from diverse backgrounds, including those who may have historically faced barriers."
              },
            {
                "verse": "Galatians 3:28",
                "text": "There is neither Jew nor Gentile, neither slave nor free, nor is there male and female, for you are all one in Christ Jesus.",
                "implication": "This verse emphasizes the fundamental equality and unity of all people in Christ, transcending social and cultural barriers. Abolishing DEI efforts could be seen as undermining the recognition and valuing of diverse backgrounds."
              }
        ],
        "tags": ["defense"]
      }, //good
      {
        "id": 36,
        "date": "2025-01-28",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "HHS",
          //"story": "Reverse prohibitions on healthcare discrimination based on gender identity.",
          "story": "Protections against healthcare discrimination based on gender identity will be eliminated.",
          "implications": "Allow healthcare providers and institutions to deny essential medical care to transgender individuals, leading to significant harm to their health and well-being.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=508"
            },
            {
                "name": "DOTW",
                "url": "https://doctorsoftheworld.org/blog/project-2025-lgbtq-rights/"
            }
          ]
        },
        "goodData": [
            {
                "verse": "Matthew 12:10-13",
                "text": "...they asked him, 'Is it lawful to heal on the Sabbath?' He said to them, 'If any of you has a sheep and it falls into a pit on the Sabbath, will you not take hold of it and lift it out? How much more valuable is a person than a sheep! Therefore it is lawful to do good on the Sabbath.'",
                "implication": "Jesus prioritized human well-being and healing over rigid adherence to rules."
              },
            {
                "verse": "Matthew 25:40",
                "text": "The King will reply, 'Truly I tell you, whatever you did for one of the least of these brothers and sisters of mine, you did for me.'",
                "implication": "Jesus identifies himself with the most vulnerable members of society."
              }
        ],
        "tags": ["dei"]
      }, //GOOD
      {
        "id": 37,
        "date": "2025-01-25",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "USAID",
          //"story": "Eliminate Chief Diversity Officer at USAID, remove DEI requirements, eliminate funding for partners that promote "discriminatory DEI practices".",
          "story": "USAID abolished its Chief Diversity Officer position, removed all DEI requirements, and cut funding to partners identified as promoting 'discriminatory DEI practices.'",
          "implications": "By dismantling its DEI infrastructure, undermining its ability to effectively address the needs of diverse populations globally and perpetuates inequalities in the distribution and impact of U.S. foreign aid.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=291"
            },
            {
                "name": "Brookings",
                "url": "https://www.brookings.edu/articles/what-comes-after-a-usaid-shutdown/"
            }
          ]
        },
        "goodData": [
            {
                "verse": "Matthew 28:19",
                "text": "Therefore go and make disciples of all nations, baptizing them in the name of the Father and of the Son and of the Holy Spirit...",
                "implication": "Jesus commanded his followers to reach out to all nations. Eliminating DEI efforts at USAID hinders the agency's ability to effectively engage with and understand the diverse needs and contexts of different cultures and populations around the world."
              },
            {
                "verse": "James 2:5-6",
                "text": "Listen, my dear brothers and sisters: Has not God chosen those who are poor in the eyes of the world to be rich in faith and to inherit the kingdom he promised those who love him? But you have dishonored the poor.",
                "implication": "James criticizes the act of showing favoritism to the rich and dishonoring the poor. USAID's mission often involves assisting impoverished and marginalized communities globally."
              },
            {
                "verse": "1 John 3:17",
                "text": "If anyone has material possessions and sees a brother or sister in need but withholds help from them, how can the love of God be in that person?",
                "implication": "This verse underscores the importance of actively helping those in need. USAID is a primary vehicle for providing aid and assistance to people around the world facing various challenges."
              }
        ],
        "tags": ["dei"]
      }, //good
      {
        "id": 39,
        "date": "2025-01-24",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "Dept of Energy",
          //"story": "Eliminate considerations of upstream and downstream greenhouse gas emissions.",
          "story": "Policies no longer take into account the upstream and downstream greenhouse gas emissions associated with various activities.",
          "implications": "Ignoring upstream and downstream emissions will lead to an incomplete and likely underestimated assessment of the environmental impact of policies, hindering effective efforts to combat climate change.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=439"
            },
            {
                "name": "Akingump",
                "url": "https://www.akingump.com/en/insights/alerts/ferc-formally-axes-its-draft-policy-statement-on-greenhouse-gas-emission-considerations-for-natural-gas-act-projects"
            },
            {
                "name": "Greenpeace",
                "url": "https://www.greenpeace.org/usa/project-2025-is-a-mandate-for-destroying-democracy-and-the-climate/"
            },
            {
                "name": "Earth Justice",
                "url": "https://earthjustice.org/article/project-2025-means-undoing-climate-solutions-well-fight-back"
            }
          ]
        },
        "goodData": [
            {
                "verse": "James 1:17",
                "text": "Every good and perfect gift is from above, coming down from the Father of the heavenly lights, who does not change like shifting shadows.",
                "implication": "The natural world and its resources can be seen as good gifts from God. Policies that lead to the degradation of the environment through a failure to account for the full impact of emissions could be viewed as a misuse and disrespect of these gifts, rather than cherishing and protecting them."
              },
            {
                "verse": "Revelation 11:18",
                "text": "...and will destroy those who destroy the earth.",
                "implication": "Policies that deliberately ignore the full impact of greenhouse gas emissions could be seen as contributing to the destruction of the earth through climate change, thus opposing God's will as suggested in this verse."
              },
            {
                "verse": "Luke 12:48",
                "text": "...From everyone who has been given much, much will be demanded; and from the one who has been entrusted with much, much more will be asked.",
                "implication": "Humanity has been given dominion over the earth (Genesis 1:28), a great responsibility. Ignoring the comprehensive impact of our actions on the environment, including upstream and downstream effects, suggests a failure to be responsible stewards of this gift, contrary to the principle outlined by Jesus."
              }
        ],
        "tags": ["environment"]
      }, //good
      {
        "id": 40,
        "date": "2025-01-24",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "Dept of Justice",
          //"story": "Avoid "politically motivated prosecutions" like of people who violate the FACE Act.",
          "story": "Weakens the legal protections for abortion clinics and their patients, leading to increased obstruction and intimidation, thus hindering access to reproductive healthcare services.",
          "implications": "Ignoring upstream and downstream emissions will lead to an incomplete and likely underestimated assessment of the environmental impact of policies, hindering effective efforts to combat climate change.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=591"
            },
            {
                "name": "CBS News",
                "url": "https://www.cbsnews.com/news/trump-face-act-abortion-related-actions-justice-department/"
            },
            {
                "name": "WLRN",
                "url": "https://www.wlrn.org/national-politics/2025-03-09/trump-dojs-limits-on-face-act-enforcement-fuel-concern-from-abortion-providers"
            },
            {
                "name": "Center For Reproductive Rights",
                "url": "https://reproductiverights.org/doj-orders-prosecutors-to-cease-face-enforcement/"
            }
          ]
        },
        "goodData": [
            {
                "verse": "Matthew 9:35-36",
                "text": "Jesus went through all the towns and villages, teaching in their synagogues, proclaiming the good news of the kingdom, and healing every disease and sickness. When he saw the crowds, he had compassion on them, because they were harassed and helpless, like sheep without a shepherd.",
                "implication": "This lack of protection for the vulnerable would likely be contrary to Jesus' compassionate nature."
              },
            {
                "verse": "Luke 13:10-13",
                "text": "On a Sabbath Jesus was teaching in one of the synagogues, and a woman was there who had been crippled by a spirit for eighteen years. She was bent over and could not straighten up at all. When Jesus saw her, he called her forward and said to her, 'Woman, you are set free from your infirmity.' Then he put his hands on her, and immediately she straightened up and praised God.",
                "implication": "Jesus prioritized healing and alleviating suffering, even when it challenged existing norms."
              },
            {
                "verse": "Matthew 25:45",
                "text": "He will reply, 'Truly I tell you, whatever you did not do for one of the least of these, you did not do for me.'",
                "implication": "A policy that weakens the protection of their access to care might be interpreted as a failure to care for those in need, which Jesus equates to neglecting him."
              }
        ],
        "tags": ["reproductive health"]
      }, //good
      {
        "id": 41,
        "date": "2025-01-20",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "White House",
          //"story": "Avoid "politically motivated prosecutions" like of people who violate the FACE Act.",
          "story": "Contracts terminated with entities determined to be enforcing policies or practices aligned with a 'woke agenda,' often interpreted as promoting diversity, equity, and inclusion initiatives or other related social justice efforts.",
          "implications": "Reduces the diversity of organizations working with the government and could hinder the advancement of diversity, equity, and inclusion in federally funded projects and services.",
          "sources": [
            {
                "name": "White House",
                "url": "https://www.whitehouse.gov/presidential-actions/2025/01/ending-radical-and-wasteful-government-dei-programs-and-preferencing/"
            },
            {
                "name": "Interfaith Alliance",
                "url": "https://www.interfaithalliance.org/post/project-2025-in-trumps-first-month-the-threat-to-lgbtq-rights-and-freedoms"
            },
            {
                "name": "USResist",
                "url": "https://www.usresistnews.org/2025/02/28/the-end-of-dei-in-the-federal-government-whos-really-affected/"
            }
          ]
        },
        "goodData": [
            {
                "verse": "Luke 6:32-33",
                "text": "If you love those who love you, what credit is that to you? Even sinners love those who love them. And if you do good to those who are good to you, what credit is that to you? Even sinners do that.",
                "implication": "Jesus calls for a love and action that extends beyond one's own group."
              },
            {
                "verse": "Matthew 22:39",
                "text": "And the second is like it: 'Love your neighbor as yourself.'",
                "implication": "Jesus' command to love one's neighbor is universal and doesn't exclude those with different perspectives or those working towards inclusivity."
              },
            {
                "verse": "James 2:1-4",
                "text": "My brothers and sisters, believers in our glorious Lord Jesus Christ, don’t show favoritism. Suppose a man comes into your meeting wearing a gold ring and fine clothes, and a poor man in ragged clothes also comes in. If you show special attention to the man wearing fine clothes and say, 'Here’s a good seat for you,' but say to the poor man, 'You stand there' or 'Sit on the floor by my feet,' have you not discriminated among yourselves and become judges with evil thoughts?",
                "implication": "Condemns showing favoritism based on social status."
              }
        ],
        "tags": ["dei"]
      }, //good
      {
        "id": 42,
        "date": "2025-01-20",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "White House",
          //"story": "Eliminate the Interagency Working Group on the Social Cost of Carbon.",
          "story": "The Interagency Working Group on the Social Cost of Carbon was eliminated, mirroring a previous action by the Trump administration that rescinded the executive order establishing the group.",
          "implications": "Hinders the government's ability to consistently and accurately assess the long-term economic damages of greenhouse gas emissions, leading to the development of less effective and economically sound climate policies.",
          "sources": [
            {
                "name": "White House",
                "url": "https://www.whitehouse.gov/presidential-actions/2025/01/unleashing-american-energy/"
            },
            {
                "name": "Pro Publica",
                "url": "https://www.propublica.org/article/trump-climate-change-social-cost-of-carbon-executive-order"
            },
            {
                "name": "American Progress",
                "url": "https://www.americanprogress.org/article/how-project-2025-threatens-the-inflation-reduction-acts-thriving-clean-energy-economy/"
            }
          ]
        },
        "goodData": [
            {
                "verse": "Matthew 6:33",
                "text": "But seek first his kingdom and his righteousness, and all these things will be given to you as well.",
                "implication": "Emphasizes prioritizing God's will and a righteous way of living. Neglecting to account for the long-term environmental consequences of our actions does not align with a righteous approach to stewardship."
              },
            {
                "verse": "Luke 12:48",
                "text": "...From everyone who has been given much, much will be demanded; and from the one who has been entrusted with much, much more will be asked.",
                "implication": "Jesus' teaching implies that we will be held accountable for how we use what we have been given."
              },
            {
                "verse": "Matthew 7:12",
                "text": "So in everything, do to others what you would have them do to you, for this sums up the Law and the Prophets.",
                "implication": "Considering the future impacts of climate change on future generations and vulnerable populations is a matter of treating others as we would want to be treated."
              }
        ],
        "tags": ["environment"]
      }, //good
      {
        "id": 43,
        "date": "2025-01-20",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "Dept of Treasury",
          //"story": "Reverse support for consideration of environmental, social, and governance principles.",
          "story": "Support for considering environmental, social, and governance (ESG) principles in policy decisions will be reversed.",
          "implications": "Leads to policies that prioritize short-term gains at the expense of the environment, society, and responsible governance.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=742"
            },
            {
                "name": "Grist",
                "url": "https://grist.org/business/trumps-energy-secretary-pushed-legal-attack-on-green-investing/"
            },
            {
                "name": "ESG Dive",
                "url": "https://www.esgdive.com/news/trump-repeals-biden-orders-clean-energy-solar-heatpumps-manufacturing/743957/"
            }
          ]
        },
        "goodData": [
            {
                "verse": "Matthew 25:31-46",
                "text": "This entire passage describes the judgment of nations based on how they treated 'the least of these' – the hungry, thirsty, strangers, naked, sick, and imprisoned.",
                "implication": "ESG principles, particularly the 'Social' aspect, often address the well-being of vulnerable populations. Reversing support for these principles could lead to policies that neglect the needs of the marginalized, which would be contrary to Jesus' emphasis on caring for the poor and those in need."
              },
            {
                "verse": "Revelation 11:18",
                "text": "....and will destroy those who destroy the earth.",
                "implication": "Underscores the importance of caring for the Earth."
              },
            {
                "verse": "Matthew 7:12",
                "text": "So in everything, do to others what you would have them do to you, for this sums up the Law and the Prophets.",
                "implication": "Considering the future impacts of climate change on future generations and vulnerable populations is a matter of treating others as we would want to be treated."
              }
        ],
        "tags": ["environment"]
      }, //good
      {
        "id": 44,
        "date": "2025-01-24",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "Dept of Labor",
          //"story": "Dept. of Labor Rescind Executive Order 11246 - Equal Opportunity Employment.",
          "story": "Rescinded Executive Order 11246, which requires equal opportunity in employment for federal contractors.",
          "implications": "Weakens the federal government's commitment to ensuring fair and equitable employment practices, leading to increased discrimination and reduced workplace diversity across the nation.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=617"
            },
            {
                "name": "Department of Labor",
                "url": "https://www.dol.gov/newsroom/releases/osec/osec20250124"
            },
            {
                "name": "National Law Review",
                "url": "https://natlawreview.com/article/breaking-president-trump-rescinds-executive-order-11246"
            },
            {
                "name": "CNN",
                "url": "https://www.cnn.com/2025/01/23/business/trump-rescinds-anti-discrimination-order/index.html"
            }
          ]
        },
        "goodData": [
            {
                "verse": "Romans 2:11",
                "text": "For God shows no partiality.",
                "implication": "This concise statement reinforces the idea that God does not favor one group over another. Rescinding a measure aimed at ensuring equal opportunity suggests a form of partiality or at least a tolerance for it in the employment sector, which would be contrary to this core attribute of God."
              },
            {
                "verse": "Matthew 7:12",
                "text": "So whatever you wish that others would do to you, do also to them, for this is the law and the prophets.",
                "implication": "This 'Golden Rule' emphasizes treating others with the same fairness and opportunity we desire for ourselves. Rescinding a policy designed to prevent discrimination in employment would violate this principle by allowing unequal treatment based on factors like race, gender, or religion."
              },
            {
                "verse": "Luke 6:31",
                "text": "And as you wish that others would do to you, do so to them.",
                "implication": "This verse calls for reciprocal fairness and equitable treatment. If individuals would not want to be denied employment opportunities based on discriminatory factors, then they should not support policies that could lead to such outcomes for others."
              },
        ],
        "tags": ["civil rights"]
      }, //good
      {
        "id": 45,
        "date": "2025-01-24",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "Dept of State",
          //"story": "Freeze "allocation of resources, foreign aid disbursements," and "hiring and recruiting decisions".",
          "story": "Halted the provision of funds, international assistance, and all new personnel actions.",
          "implications": "This abrupt freeze severely impedes the nation's ability to conduct diplomacy, provide essential humanitarian aid, and maintain a fully functioning foreign service, damaging international relations and creating global instability.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=207"
            },
            {
                "name": "NBC",
                "url": "https://www.nbcnews.com/politics/politics-news/marco-rubio-orders-halt-almost-us-foreign-aid-rcna189230"
            }
          ]
        },
        "goodData": [
            {
                "verse": "Matthew 25:35-36",
                "text": "For I was hungry and you gave me food, I was thirsty and you gave me drink, I was a stranger and you welcomed me, I was naked and you clothed me, I was sick and you visited me, I was in prison and you came to me.",
                "implication": "Jesus emphasizes the importance of providing aid and care to those in need. Freezing the allocation of resources and foreign aid directly contradicts this teaching by hindering the ability to help the hungry, thirsty, and those in vulnerable situations around the world."
              },
            {
                "verse": "James 2:15-16",
                "text": "If a brother or sister is poorly clothed and lacking in daily food, and one of you says to them, 'Go in peace, be warmed and filled,' without giving them the things needed for the body, what good is that?",
                "implication": "This passage criticizes empty words without corresponding action to meet genuine needs."
              },
            {
                "verse": "Matthew 9:36",
                "text": "When he saw the crowds, he had compassion for them, because they were harassed and helpless, like sheep without a shepherd.",
                "implication": "Jesus was moved by compassion for those who were vulnerable and lacking guidance."
              },
        ],
        "tags": ["aid"]
      }, //good
      {
        "id": 46,
        "date": "2025-01-24",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "Dept of State",
          //"story": "Prohibit the flying of "Divisive symbols such as the rainbow flag or the Black Lives Matter flag" at U.S. embassies.",
          "story": "U.S. embassies are now banned from displaying symbols like the rainbow flag and the Black Lives Matter flag.",
          "implications": "Diminishes the visibility and affirmation of marginalized communities on the global stage, signaling a potential shift away from the promotion of inclusivity and human rights in U.S. foreign policy.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=122"
            },
            {
                "name": "New York Times",
                "url": "https://www.nytimes.com/2025/01/24/us/embassy-us-flag-blm-gay-pride.html"
            },
            {
                "name": "NBC",
                "url": "https://www.nbcpalmsprings.com/2025/01/23/trumps-one-flag-policy-ends-pride-and-other-flag-displays-at-embassies-and-government-buildings"
            },
            {
                "name": "Newsweek",
                "url": "https://www.newsweek.com/trump-bans-pride-blm-flags-report-2018810"
            }
          ]
        },
        "goodData": [
            {
                "verse": "Romans 2:11",
                "text": "For God shows no partiality.",
                "implication": "This concise statement reinforces the idea that God does not favor one group over another. Rescinding a measure aimed at ensuring equal opportunity suggests a form of partiality or at least a tolerance for it in the employment sector, which would be contrary to this core attribute of God."
              },
            {
                "verse": "Matthew 7:12",
                "text": "So whatever you wish that others would do to you, do also to them, for this is the law and the prophets.",
                "implication": "This 'Golden Rule' emphasizes treating others with the same fairness and opportunity we desire for ourselves. Rescinding a policy designed to prevent discrimination in employment would violate this principle by allowing unequal treatment based on factors like race, gender, or religion."
              },
            {
                "verse": "Luke 6:31",
                "text": "And as you wish that others would do to you, do so to them.",
                "implication": "This verse calls for reciprocal fairness and equitable treatment. If individuals would not want to be denied employment opportunities based on discriminatory factors, then they should not support policies that could lead to such outcomes for others."
              },
        ],
        "tags": ["dei"]
      }, //good
      {
        "id": 47,
        "date": "2025-01-22",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "White House",
          //"story": "Clear out the NSC, replace "all essential detailees with staff aligned to the new President's priorities".",
          "story": "Removed career professionals and subject matter experts from the National Security Council, replacing them with individuals primarily chosen for their loyalty to the President's agenda.",
          "implications": "Undermines the quality of national security advice by prioritizing political alignment over expertise and leads to less informed and more ideologically driven foreign policy decisions.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=85"
            },
            {
                "name": "Washington Post",
                "url": "https://www.washingtonpost.com/national-security/2025/01/22/trump-waltz-national-security-council-officials/"
            },
            {
                "name": "Whyy",
                "url": "https://whyy.org/articles/donald-trump-team-questioning-civil-servants-national-security-council/"
            }
          ]
        },
        "goodData": [
            {
                "verse": "Philippians 2:3-4",
                "text": "Do nothing from selfish ambition or conceit, but in humility count others more significant than yourselves. Let each of you look not only to his own interests, but also to the interests of others.",
                "implication": "Jesus taught humility and prioritizing the needs of others. Staffing the NSC based solely on loyalty to the President's personal agenda, rather than on the expertise and experience needed to serve the best interests of the country, could be seen as driven by selfish ambition rather than humble service."
              },
            {
                "verse": "James 3:17",
                "text": "But the wisdom from above is first pure, then peaceable, gentle, open to reason, full of mercy and good fruits, impartial and sincere.",
                "implication": "Replacing experienced staff with those primarily aligned politically compromise the impartiality and openness to reason that are crucial for sound national security advice."
              },
            {
                "verse": "Matthew 7:15",
                "text": "Beware of false prophets, who come to you in sheep's clothing but inwardly are ravenous wolves.",
                "implication": " If individuals are appointed to the NSC primarily based on their willingness to agree with the President rather than their genuine expertise and commitment to national security, they could provide biased or self-serving advice, harming the nation in the long run."
              },
        ],
        "tags": ["presidential power"]
      }, //good
      {
        "id": 48,
        "date": "2025-03-20",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "Dept of Education",
          //"story": "Break up the Department of Education.",
          "story": "Dismantled the Department of Education.",
          "implications": "Decreases national standards and equity in education across different states and districts.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=352"
            },
            {
                "name": "AP News",
                "url": "https://apnews.com/article/trump-education-department-shutdown-b1d25a2e1bdcd24cfde8ad8b655b9843"
            },
            {
                "name": "Brookings",
                "url": "https://www.brookings.edu/articles/project-2025-and-education-a-lot-of-bad-ideas-some-more-actionable-than-others/"
            }
          ]
        },
        "goodData": [
            {
                "verse": "Matthew 18:6",
                "text": "But whoever causes one of these little ones who believe in me to sin, it would be better for him to have a great millstone fastened around his neck and to be drowned in the depth of the sea.",
                "implication": "Emphasizes the importance of protecting and nurturing the well-being of children. "
              },
            {
                "verse": "John 17:21",
                "text": "that they may all be one, just as you, Father, are in me, and I in you, that they also may be in us, so that the world may believe that you have sent me.",
                "implication": "Jesus prayed for unity among his followers. A unified Department of Education could promote more consistent standards and practices across the nation, fostering a sense of shared educational goals."
              }
        ],
        "tags": ["education"]
      }, //good
      {
        "id": 49,
        "date": "2025-03-21",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "Homeland Security",
          //"story": "Eliminate the Office of the Citizenship and Immigration Services Ombudsman.",
          "story": "Abolish the Office of the Citizenship and Immigration Services, the body that helps individuals and employers resolve issues with U.S. Citizenship and Immigration.",
          "implications": "Reduces avenue for individuals facing bureaucratic challenges with immigration services to seek impartial assistance and resolution.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=199"
            },
            {
                "name": "CBS News",
                "url": "https://www.cbsnews.com/news/trump-administration-gutting-dhs-civil-rights-branch/"
            }
          ]
        },
        "goodData": [
            {
                "verse": "James 1:27",
                "text": "Religion that is pure and undefiled before God the Father is this: to visit orphans and widows in their affliction, and to keep oneself unstained from the world.",
                "implication": "Highlights the importance of caring for the vulnerable and those facing hardship."
              },
            {
                "verse": "Hebrews 13:2",
                "text": "Do not neglect to show hospitality to strangers, for thereby some have entertained angels unawares.",
                "implication": "Encourages kindness and welcome towards foreigners."
              },
            {
                "verse": "Matthew 25:35",
                "text": "For I was hungry and you gave me food, I was thirsty and you gave me drink, I was a stranger and you welcomed me.",
                "implication": "Jesus commends those who welcome strangers."
              },
        ],
        "tags": ["immigration"]
      }, //good
      {
        "id": 50,
        "date": "2025-03-21",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "Homeland Security",
          //"story": "Eliminate the Office of Immigration Detention Ombudsman.",
          "story": "Eliminated the Office of Immigration Detention, abolish the governmental body responsible for overseeing and managing the detention of individuals awaiting immigration proceedings.",
          "implications": "Reduces oversight and accountability regarding the treatment and conditions of individuals held in immigration detention facilities.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=198"
            },
            {
                "name": "CBS News",
                "url": "https://www.cbsnews.com/news/trump-administration-gutting-dhs-civil-rights-branch/"
            },
            {
                "name": "Washington Post",
                "url": "https://www.washingtonpost.com/immigration/2025/03/21/dhs-immigrant-advocates-watchdogs-oversight/"
            }
          ]
        },
        "goodData": [
            {
                "verse": "Matthew 25:36",
                "text": "I was naked and you clothed me, I was sick and you visited me, I was in prison and you came to me.",
                "implication": "Jesus identifies himself with those who are imprisoned. Eliminating an office responsible for overseeing immigration detention could lead to neglect and mistreatment of detainees, which would be contrary to the spirit of visiting and caring for those in prison."
              },
            {
                "verse": "Hebrews 13:3",
                "text": "Remember those who are in prison, as though in prison with them, and those who are mistreated, as though you yourselves were suffering.",
                "implication": " This verse urges believers to empathize with and remember those who are imprisoned and mistreated."
              },
            {
                "verse": "Matthew 7:12",
                "text": "So whatever you wish that others would do to you, do also to them, for this is the law and the prophets.",
                "implication": "This 'Golden Rule' calls for treating others as we would want to be treated. Without an office dedicated to oversight, there is a greater risk that detainees might face conditions that we ourselves would not want to endure, violating this fundamental principle."
              },
        ],
        "tags": ["immigration"]
      }, //good
      {
        "id": 51,
        "date": "2025-03-21",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "Homeland Security",
          //"story": "Eliminate the Office for Civil Rights and Civil Liberties.",
          "story": "Eliminating the Office for Civil Rights and Civil Liberties means abolishing the government body responsible for ensuring adherence to civil rights and liberties within federal agencies and programs.",
          "implications": "Weakens federal capacity to investigate and address violations of civil rights and civil liberties, leading to less accountability and protection for individuals.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=197"
            },
            {
                "name": "NY Times",
                "url": "https://www.nytimes.com/2025/03/21/us/politics/trump-civil-rights-homeland-security-deportations.html"
            }
          ]
        },
        "goodData": [
            {
                "verse": "Galatians 3:28",
                "text": "There is neither Jew nor Gentile, neither slave nor free, neither male nor female, for you are all one in Christ Jesus.",
                "implication": "This verse emphasizes equality and the absence of discrimination in Christ. The Office for Civil Rights and Civil Liberties was intended to uphold these principles within federal programs. Its elimination could undermine the pursuit of equality and non-discrimination."
              },
            {
                "verse": "Matthew 23:23",
                "text": "Woe to you, scribes and Pharisees, hypocrites! For you tithe mint and dill and cumin, and have neglected the weightier matters of the law: justice and mercy and faithfulness. These you ought to have done, without neglecting the others.",
                "implication": "Jesus criticizes those who focus on minor details while neglecting the core principles of justice and mercy. The protection of civil rights and civil liberties is a fundamental aspect of justice. "
              },
            {
                "verse": "Matthew 5:9",
                "text": "Blessed are the peacemakers, for they shall be called sons of God.",
                "implication": "The pursuit of justice and the protection of rights are essential for societal peace."
              },
        ],
        "tags": ["civil rights"]
      }, //good
      {
        "id": 52,
        "date": "2025-03-21",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "Personnel",
          //"story": "Weaken federal employee unions.",
          "story": "Weakened federal employee unions; diminishing the power of organized labor representing federal workers to collectively bargain for wages, benefits, and working conditions.",
          "implications": "Decreased job security and reduced ability to advocate for their interests.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=114"
            },
            {
                "name": "White House",
                "url": "https://www.whitehouse.gov/fact-sheets/2025/03/fact-sheet-president-donald-j-trump-exempts-agencies-with-national-security-missions-from-federal-collective-bargaining-requirements/"
            }
          ]
        },
        "goodData": [
            {
                "verse": "James 5:4",
                "text": "Behold, the wages of the laborers who mowed your fields, which you kept back by fraud, are crying out against you, and the cries of the harvesters have reached the ears of the Lord of hosts.",
                "implication": "This verse speaks against the unjust treatment of workers and the withholding of fair wages. Weakening unions can lead to a situation where federal workers have less power to negotiate for fair compensation and benefits, potentially leading to exploitation."
              },
            {
                "verse": "Matthew 10:10",
                "text": "...for the laborer deserves his food.",
                "implication": "Jesus acknowledges the right of workers to fair compensation and sustenance. Unions play a role in advocating for the economic well-being of their members. Weakening them could hinder the ability of federal workers to secure just rewards for their labor."
              },
            {
                "verse": "Philippians 2:4",
                "text": "Let each of you look not only to his own interests, but also to the interests of others.",
                "implication": "This verse encourages considering the well-being of others. Unions are formed to collectively represent the interests of workers, ensuring that their needs and concerns are addressed. Weakening them could prioritize individual interests over the collective good and potentially harm the overall workforce. "
              },
        ],
        "tags": ["unions"]
      }, //good
      {
        "id": 53,
        "date": "2025-04-01",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "Dept of Agriculture",
          //"story": "Restrict the Low-Income Heat and Energy Assistance Program (LIHEAP).",
          "story": "Eliminated federal funding and support for LIHEAP, a program that helps low-income households pay their heating and cooling bills, by way of firing of all its staff.",
          "implications": "Millions of vulnerable families, particularly the elderly and those with young children, face increased risk of health problems and homelessness due to inability to afford essential heating and cooling.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=334"
            },
            {
                "name": "CNN",
                "url": "https://www.cnn.com/2025/04/01/health/staff-cuts-at-federal-health-agencies-have-begun/index.html"
            },
            {
                "name": "NBC",
                "url": "https://www.nbcnews.com/business/business-news/trump-admin-fires-staff-liheap-agency-utilities-assistance-program-rcna199177"
            },
            {
                "name": "Politico",
                "url": "https://www.politico.com/news/2025/03/26/energy-department-hydrogen-projects-blue-states-00249589"
            }
          ]
        },
        "goodData": [
            {
                "verse": "Luke 6:20",
                "text": "And he lifted up his eyes on his disciples, and said: “Blessed are you who are poor, for yours is the kingdom of God.",
                "implication": "Jesus showed particular compassion for the poor. LIHEAP directly assists low-income individuals. Eliminating this support would exacerbate their hardship, contradicting Jesus' message of blessing and care for the poor."
              },
            {
                "verse": "James 2:15-16",
                "text": "If a brother or sister is poorly clothed and lacking in daily food, and one of you says to them, “Go in peace, be warmed and filled,” without giving them the things needed for the body, what good is that?",
                "implication": "This passage emphasizes the importance of providing practical help to those in need. LIHEAP provides the tangible assistance of helping people afford heating and cooling. Restricting it would be akin to offering empty words without addressing the real physical needs of vulnerable individuals."
              },
            {
                "verse": "Matthew 5:7",
                "text": "Blessed are the merciful, for they shall receive mercy.",
                "implication": "Jesus taught the importance of mercy. LIHEAP is a program designed to provide mercy to those struggling to afford basic necessities like heating and cooling. Restricting it demonstrates a lack of mercy towards vulnerable populations."
              },
        ],
        "tags": ["welfare"]
      }, //good (ending 4/1/25)
      {
        "id": 54,
        "date": "2025-04-08",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "Commodity Futures Commission",
          //"story": "Reduce regulations on cryptocurrencies.",
          "story": "Reduce regulations on cryptocurrencies, along with the DOJ's instruction to ease enforcement, shows a strong move toward less government oversight of the digital asset market.",
          "implications": "This decrease in scrutiny and enforcement increases the potential for fraudulent activities and financial risks for investors within the cryptocurrency space.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=868"
            },
            {
                "name": "ABC",
                "url": "https://abcnews.go.com/Politics/trump-admin-tells-prosecutors-ease-crypto-enforcement/story?id=120589406"
            },
            {
                "name": "Reuters",
                "url": "https://www.reuters.com/world/us/us-justice-dept-disbands-cryptocurrency-enforcement-unit-2025-04-08/"
            },
            {
                "name": "The Guardian",
                "url": "https://www.theguardian.com/us-news/2025/apr/08/trump-crypto-doj"
            }
          ]
        },
        "goodData": [
            {
                "verse": "Luke 16:10",
                "text": "Whoever can be trusted with very little can also be trusted with much, and whoever is dishonest with very little will also be dishonest with much.",
                "implication": "Looser regulations and enforcement in the cryptocurrency market creates opportunities for dishonesty on a large scale. Jesus' emphasis on trustworthiness in small matters suggests he would oppose systems that make large-scale dishonesty easier."
              },
            {
                "verse": "James 5:1-6",
                "text": "Now listen, you rich people, weep and wail because of the misery that is coming on you. Your wealth has rotted, and moths have eaten your clothes. Your gold and silver are corroded. Their corrosion will testify against you and eat your flesh like fire. You have hoarded wealth in the last days. Look! The wages you failed to pay the workers who mowed your fields are crying out against you...",
                "implication": "Condemnation of those who amass wealth unjustly and through the exploitation of others. Reduced regulations in a volatile market like cryptocurrency enables exploitation and leads to the financial ruin of vulnerable individuals."
              },
            {
                "verse": "Matthew 6:24",
                "text": "No one can serve two masters. Either you will hate the one and love the other, or you will be devoted to the one and despise the other. You cannot serve both God and money.",
                "implication": "Allowing exploitation of others that fuel unjust wealth accumulation is in opposition to Jesus' teachings."
              },
        ],
        "tags": ["economy", "regulation"]
      }, //good (ending 4/8/25)
      {
        "id": 55,
        "date": "2025-04-11",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "Dept of Homeland Security",
          //"story": "Create a "single nationwide detention standard" that includes the "flexibility to use large numbers of temporary facilities such as tents"..",
          "story": "Doctrined the 'single nationwide detention standard' with the flexibility to use temporary facilities like tent complexes; meaning the government can detain a large number of immigrants anywhere using temporary structures.",
          "implications": "Reduced oversight and inconsistent, often inhumane, living conditions across different detention sites.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=173"
            },
            {
                "name": "Pro Publica",
                "url": "https://www.propublica.org/article/trump-deportations-deployed-resources-tent-company?utm_source=bluesky&utm_medium=social&utm_campaign=propublica-bsky&utm_content=3"
            }
          ]
        },
        "goodData": [
            {
                "verse": "Matthew 25:35",
                "text": "For I was hungry and you gave me something to eat, I was thirsty and you gave me something to drink, I was a stranger and you invited me in.",
                "implication": "Jesus emphasizes welcoming strangers and providing for their basic needs, contrasting with the impersonal nature and inadequacy of large, temporary detention facilities."
              },
            {
                "verse": "Matthew 25:40",
                "text": "...‘Truly I tell you, whatever you did for one of the least of these brothers and sisters of mine, you did for me.",
                "implication": "Jesus identifies himself with the vulnerable, suggesting that the treatment of detained immigrants reflects directly on how one treats him."
              },
            {
                "verse": "Matthew 7:12",
                "text": "So in everything, do to others what you would have them do to you, for this sums up the Law and the Prophets.",
                "implication": "This 'Golden Rule'suggests treating immigrants in detention with the dignity and care one would expect for oneself or their loved ones in a similar situation, which might be compromised in large, temporary facilities."
              },
        ],
        "tags": ["immigration"]
      }, //good (ending 
      {
        "id": 56,
        "date": "2025-04-08",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "Dept of Homeland Security",
          //"story": "Lift the coal leasing moratorium by reinstating SO 3348.",
          "story": "Doctrined the 'single nationwide detention standard' with the flexibility to use temporary facilities like tent complexes; meaning the government can detain a large number of immigrants anywhere using temporary structures.",
          "implications": "Reduced oversight and inconsistent, often inhumane, living conditions across different detention sites.",
          "sources": [
            {
                "name": "Project 2025",
                "url": "https://static.project2025.org/2025_MandateForLeadership_FULL.pdf#page=555"
            },
            {
                "name": "Dept of Interior",
                "url": "https://www.doi.gov/pressreleases/department-interior-moves-restore-coal-industry"
            },
            {
                "name": "ABC",
                "url": "https://abcnews.go.com/US/trump-clean-coal-thing/story?id=119920490"
            },
            {
                "name": "Global Energy Policy",
                "url": "https://www.energypolicy.columbia.edu/trumps-misleading-promotion-of-clean-coal/"
            }
          ]
        },
        "goodData": [
            {
                "verse": "Matthew 25:35",
                "text": "For I was hungry and you gave me something to eat, I was thirsty and you gave me something to drink, I was a stranger and you invited me in.",
                "implication": "Jesus emphasizes welcoming strangers and providing for their basic needs, contrasting with the impersonal nature and inadequacy of large, temporary detention facilities."
              },
            {
                "verse": "Matthew 25:40",
                "text": "...‘Truly I tell you, whatever you did for one of the least of these brothers and sisters of mine, you did for me.",
                "implication": "Jesus identifies himself with the vulnerable, suggesting that the treatment of detained immigrants reflects directly on how one treats him."
              },
            {
                "verse": "Matthew 7:12",
                "text": "So in everything, do to others what you would have them do to you, for this sums up the Law and the Prophets.",
                "implication": "This 'Golden Rule'suggests treating immigrants in detention with the dignity and care one would expect for oneself or their loved ones in a similar situation, which might be compromised in large, temporary facilities."
              },
        ],
        "tags": ["energy", "environment"]
      },
      {
        "id": 57,
        "date": "2025-05-09",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "Environmental Protection Agency",
          "story": "EPA forced to roll back Biden-era efficiency standards.",
          "implications": "Increased energy consumption, higher utility bills for consumers, and a potential rise in greenhouse gas emissions due to less efficient appliances.",
          "sources": [
            {
              "name": "PBS",
              "url": "https://www.pbs.org/newshour/politics/watch-trump-signs-measures-rolling-back-biden-era-energy-efficiency-regulations"
            },
            {
              "name": "New York Times",
              "url": "https://www.nytimes.com/2025/05/12/climate/energy-effiency-programs-department-of-energy.html"
            },
            {
              "name": "Project 2025",
              "url": "https://www.mandateforleadership.org/#page=412"
            }
          ]
        },
        "goodData": [
          {
            "verse": "Romans 8:19-22",
            "text": "For the creation waits in eager expectation for the children of God to be revealed.",
            "implication": "Suggests that creation itself suffers and longs for redemption, implying a responsibility for humanity, as 'children of God,' to work towards its liberation and well-being."
          },
          {
            "verse": "1 Corinthians 4:2",
            "text": "Moreover, it is required of stewards that they be found faithful.",
            "implication": "This verse emphasizes faithfulness in stewardship. Applying this to resources, it suggests that those entrusted with managing the Earth's resources, including energy, are called to do so responsibly and wisely, rather than in a way that leads to waste or harm."
          },
          {
            "verse": "Colossians 1:16-17",
            "text": "For by him all things were created, in heaven and on earth, visible and invisible, whether thrones or dominions or rulers or authorities—all things were created through him and for him. He is before all things, and in him all things hold together.",
            "implication": "This verse establishes Christ as the Creator and sustainer of all things. Understanding creation as belonging to and being held together by Christ implies a reverence for it and a responsibility to care for it, including its resources, in a way that honors its divine origin."
          }
        ],
        "tags": ["energy", "environment"]
      },
      {
        "id": 58,
        "date": "2025-05-09",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "Department of Justice",
          "story": "Rescinded Attorney General Garland's policy that limited the Department's ability to subpoena journalists during leak investigations.",
          "implications": "Deters investigative journalism, making it more difficult for the public to receive information on government activities, especially those deemed sensitive or controversial, by increasing the risk for journalists and their confidential sources.",
          "sources": [
            {
              "name": "Politico",
              "url": "https://www.politico.com/news/2025/04/25/justice-depatment-journalists-leaks-investigations-00311515"
            },
            {
              "name": "Project 2025 (Mandate for Leadership)",
              "url": "https://www.mandateforleadership.org/#page=247"
            }
          ]
        },
        "goodData": [
          {
            "verse": "John 8:32",
            "text": "Then you will know the truth, and the truth will set you free.",
            "implication": "Jesus emphasizes the liberating power of truth. Restricting the free flow of information from journalists could hinder the public's ability to 'know the truth' about government actions, thereby limiting their freedom to make informed decisions."
          },
          {
            "verse": "Ephesians 4:25",
            "text": "Therefore each of you must put off falsehood and speak truthfully to your neighbor, for we are all members of one body.",
            "implication": "This verse calls for truthfulness within a community. In a broader societal sense, a government's transparency and willingness to allow the press to reveal information, even if uncomfortable, contributes to a more honest and trusting 'body' or society."
          },
          {
            "verse": "Romans 13:3-4",
            "text": "For rulers hold no terror for those who do right, but for those who do wrong. Do you want to be free from fear of the one in authority? Then do what is right and you will be commended. For the one in authority is God’s servant for your good. But if you do wrong, be afraid, for rulers do not bear the sword for no reason. They are God’s servants, agents of wrath to bring punishment on the wrongdoer.",
            "implication": "While acknowledging the role of authorities, this passage implies that just governance should commend those who do right and only instill fear in wrongdoers. "
          }
        ],
        "tags": ["media", "justice", "government oversight"]
      },
      {
        "id": 59,
        "date": "2025-04-18",
        "subject": "Policy Change",
        "inEffect": true,
        "badData": {
          "department": "Department of Homeland Security",
          "story": "Authorized state and local law enforcement to participate in immigration actions, expanding the scope of their involvement beyond traditional criminal enforcement to include immigration-related duties.",
          "implications": "This policy blurs the lines between federal immigration enforcement and local policing, eroding trust between immigrant communities and local law enforcement.",
          "sources": [
            {
              "name": "CBS",
              "url": "https://www.cbsnews.com/news/ice-partnerships-local-law-enforcement-trump-immigration/"
            }
          ]
        },
        "goodData": [
          {
            "verse": "Matthew 25:35",
            "text": "For I was hungry and you gave me something to eat, I was thirsty and you gave me something to drink, I was a stranger and you invited me in.",
            "implication": "Jesus' teaching to welcome the stranger stands in stark contrast to policies that could lead to increased fear and apprehension of immigrants, suggesting a call for compassion and hospitality rather than expanded enforcement."
          },
          {
            "verse": "Romans 13:1",
            "text": "Let everyone be subject to the governing authorities, for there is no authority except that which God has established. The authorities that exist have been established by God.",
            "implication": "When law enforcement's role shifts to include immigration enforcement in a way that creates fear and distrust, it raises questions about whether this aligns with authorities acting for the overall good and upholding justice for all members of society."
          },
          {
            "verse": "Acts 17:26",
            "text": "From one man he made all the nations, that they should inhabit the whole earth; and he marked out their appointed times in history and the boundaries of their lands.",
            "implication": "This verse emphasizes the shared humanity and common origin of all nations. Policies that lead to the increased targeting or fear among specific groups of people, such as immigrants, could be seen as undermining this biblical understanding of unity and interconnectedness among all people."
          }
        ],
        "tags": ["immigration", "police", "justice"]
      },

  ];
  
  export default data;
  

// Rewrite this sentence, explaining what it means in less than one sentence and give a 1 sentence negative implication of what it means negatively for policy in this country. This is a project 2025 change in effect.

// Find me two to three news articles that consider the change as a bad thing. Be sure to include the URL. These are absolutely recent and true changes in the US government, find real links.

// Then find 5 new testament verses that would imply Jesus would oppose this change and the implication of each verse.

//Never use words that indicate it 'COULD' happen, ex: potentially. This happened already and has effects.